var asyncFlag = false;
var asyncAPI = false;

var templateType,pdpType_low,designType,design_type;
function setProductAttributes(attrObj){
  console.log("setTemplateType>>>>>>>",attrObj);
  pdpType_low = attrObj.dataset.type;
  designType = attrObj.dataset.designtype;
  if(templateType == undefined || templateType == null){
    templateType = attrObj.dataset.templateType;
  }
  console.log("pdpType_low",pdpType_low,"designType",designType,"templateType",templateType);
}

function questionsCounter(){
  var activeElem = document.querySelectorAll('[data-fitsmart-questions-main] .Im-New-Filter input:checked').length;
  var totalElem = document.querySelectorAll('[data-fitsmart-questions-main] .Im-New-Filter .ProductSize__Elements').length;
  var progressBar = activeElem/totalElem*100;
  $('[data-product-fitsmart-global] .fit_progressbar span').css('width',progressBar+'%');
  // if($(".size-pop-profile:not(.hide)").length > 0){
  //   activeElem = 3;
  // }
  $('[data-product-fitsmart-global] .selFit').html(activeElem);
  $('[data-product-fitsmart-global] .totFit').html(totalElem);
  if(activeElem == totalElem){
    $('[data-calculate-fitsmart]').removeClass('disCalculatebtn');
  }else{
    $('[data-calculate-fitsmart]').addClass('disCalculatebtn');
  }
  console.log("questionsCounter>>>>>>>>",activeElem);
}

function toggleBodyScanGif(show) {
  const imgSelector = '.scan-success-loader img[alt="bodyscan gif"]';
  const imgHTML = `
    <img alt="bodyscan gif" src="//www.bombayshirts.com/cdn/shop/t/620/assets/bodyscan.gif?v=176693219851818207931761544141">
  `;

  if (show) {
    if (!$(imgSelector).length) {
      $('.scan-success-loader .content').prepend(imgHTML);
      console.log("show gif if");
      
    }
  } else {
    $(imgSelector).remove();
    console.log("remove gif else");
  }
}


  var createMeasurementCOUNTER = 0;
  var fitsmartObject1;
  var bscFlag = false;
  var korraFlag = false;
  var fitSmartProfiles;
  // define product attributes like pdpType, designType and templateType
  if(document.body.classList.contains("template-product")){
    templateType = document.body.dataset.templateType;
    setProductAttributes(document.querySelector("[data-product-fitsmart-attributes-ele].active"));
  }
  console.log("templateType",templateType);
  
  function setLocalStoreData(bodyType,hipClass,height,shirtSize,shoulderType,preferredFit,subSize,silhouetteData,pdpType_low,designType='',fitSmartType='CUSTOM'){
    console.log("setLocalStoreData>>>>>");
    fitsmartObject = localStorage.getItem("fitsmartobjNew");
    console.log("test shirt");
    if(typeof fitsmartObject === 'undefined' || fitsmartObject === null ){
      fitsmartObject = [];
    } else {
      fitsmartObject = JSON.parse(fitsmartObject);
    }
  
    // for jacket ==> semi-stitched
    var jacketSS = $.grep(fitsmartObject, function(e){
      return e.category == 'jackets' && e.designType == 'SEMI_STITCHED';
    });
    console.log("jacketSS",jacketSS);
    if(jacketSS.length){
      var newSize = jacketSS[0]['_Size?'];
      let needToRemoveJacketObj = false;
      if( bodyType == 'athletic'){
        if(newSize > 44){
          needToRemoveJacketObj = true;
        }
      }else if(bodyType == 'average' ){
        if(newSize > 48){	
          needToRemoveJacketObj = true;
        }
      }else if(bodyType == 'healthy' ){
        if(newSize < 40){
          needToRemoveJacketObj = true;
        }else if(jacketSS[0]["_Preferred Fit?"] == "Slim"){
          needToRemoveJacketObj = true;
        }
      }
      console.log("needToRemoveJacketObj",needToRemoveJacketObj);
      if(needToRemoveJacketObj){
        let itemArr = [];
        fitsmartObject.forEach(item => {
          if(item.category == "jackets" && item.designType == "SEMI_STITCHED"){}
          else{
            itemArr.push(item);
          }
        });
        subSize = undefined;
        console.log("itemArr JACKET",itemArr);
        localStorage.setItem("fitsmartobjNew", JSON.stringify(itemArr));
        fitsmartObject = itemArr;
      }
    }

  // for suit blazer ==> semi-stitched
    var suitBlazer = $.grep(fitsmartObject, function(e){
      return e.category == 'SUIT_BLAZER' && e.designType == 'SEMI_STITCHED';
    });
    console.log("suitblazer",suitBlazer);
    if(suitBlazer.length){
      var newSize = suitBlazer[0]['_Size?'];
      let needToRemoveSBObj = false;
      if( bodyType == 'athletic'){
        if(newSize > 44){
          needToRemoveSBObj = true;
        }
      }else if(bodyType == 'average' ){
        if(newSize > 48){	
          needToRemoveSBObj = true;
        }
      }else if(bodyType == 'healthy' ){
        if(newSize < 40){
          needToRemoveSBObj = true;
        }else if(suitBlazer[0]["_Preferred Fit?"] == "Slim"){
          needToRemoveSBObj = true;
        }
      }
      console.log("needToRemoveSBObj",needToRemoveSBObj);
      if(needToRemoveSBObj){
        let itemArr = [];
        fitsmartObject.forEach(item => {
          if(item.category == "SUIT_BLAZER" && item.designType == "SEMI_STITCHED"){}
          else{
            itemArr.push(item);
          }
        });
        subSize = undefined;
        console.log("itemArr SUIT_BLAZER",itemArr);
        localStorage.setItem("fitsmartobjNew", JSON.stringify(itemArr));
        fitsmartObject = itemArr;
      }
    }
    // for long jacket ==> semi-stitched
    var longjacketSS = $.grep(fitsmartObject, function(e){
      return e.category == 'LONG_JACKETS' && e.designType == 'SEMI_STITCHED';
    });
    console.log("long jacketSS",longjacketSS);
    if(longjacketSS.length){
      var newSize = longjacketSS[0]['_Size?'];
      let needToRemoveLongJacketObj = false;
      if( bodyType == 'athletic'){
        if(newSize > 44){
          needToRemoveLongJacketObj = true;
        }
      }else if(bodyType == 'average' ){
        if(newSize > 48){	
          needToRemoveLongJacketObj = true;
        }
      }else if(bodyType == 'healthy' ){
        if(newSize < 40){
          needToRemoveLongJacketObj = true;
        }else if(longjacketSS[0]["_Preferred Fit?"] == "Slim"){
          needToRemoveLongJacketObj = true;
        }
      }
      console.log("needToRemoveLongJacketObj",needToRemoveLongJacketObj);
      if(needToRemoveLongJacketObj){
        let itemArr = [];
        fitsmartObject.forEach(item => {
          if(item.category == "LONG_JACKETS" && item.designType == "SEMI_STITCHED"){}
          else{
            itemArr.push(item);
          }
        });
        subSize = undefined;
        console.log("itemArr LONG JACKET",itemArr);
        localStorage.setItem("fitsmartobjNew", JSON.stringify(itemArr));
        fitsmartObject = itemArr;
      }
    }
  
    // for bundi ==> semi-stitched
    var bundiSS = $.grep(fitsmartObject, function(e){
      return e.category == 'bundi';
    });
    console.log("bundiSS",bundiSS);
    if(bundiSS.length){
      var newSize = bundiSS[0]['_Size?'];
      let needToRemoveBundiObj = false;
      if( bodyType == 'athletic'){
        if(newSize > 44){
          needToRemoveBundiObj = true;
        }
      }else if(bodyType == 'average' ){
        if(newSize > 48){	
          needToRemoveBundiObj = true;
        }
      }else if(bodyType == 'healthy' ){
        if(newSize < 40){
          needToRemoveBundiObj = true;
        }else if(bundiSS[0]["_Preferred Fit?"] == "Slim"){
          needToRemoveBundiObj = true;
        }
      }
      console.log("needToRemoveBundiObj",needToRemoveBundiObj);
      if(needToRemoveBundiObj){
        let itemArr = [];
        fitsmartObject.forEach(item => {
          if(item.category == "bundi"){}
          else{
            itemArr.push(item);
          }
        });
        subSize = undefined;
        console.log("itemArr BUNDI",itemArr);
        localStorage.setItem("fitsmartobjNew", JSON.stringify(itemArr));
        fitsmartObject = itemArr;
      }
    }
    
    // for shirt ==> CUSTOM_DESIGN
    var shirtCD = $.grep(fitsmartObject, function(e){
      return e.category == 'shirt' && e.designType == 'CUSTOM_DESIGN';
    });
    console.log("shirtCD",shirtCD);
    if(shirtCD.length){
      let sizeTableN = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
      var st_sizeN = shirtCD[0]['_Shirt Size?'];
      var newSize = sizeTableN[st_sizeN];
      let needToRemoveShirtObj = false;
      if(bodyType == 'athletic'){
        if(newSize > 44){
          needToRemoveShirtObj = true;
        }
      }else if(bodyType == 'average'){
        if(newSize > 48){	
          needToRemoveShirtObj = true;
        }
      }else if(bodyType == 'healthy'){
        if(newSize < 40){
          needToRemoveShirtObj = true;
        }
      }
      console.log("needToRemoveShirtObj",needToRemoveShirtObj);
      if(needToRemoveShirtObj){
        let itemArr = [];
        fitsmartObject.forEach(item => {
          if(item.category == "shirt" && item.designType == "CUSTOM_DESIGN"){}
          else{
            itemArr.push(item);
          }
        });
        shirtSize = undefined;
        console.log("itemArr SHIRT",itemArr);
        localStorage.setItem("fitsmartobjNew", JSON.stringify(itemArr));
        fitsmartObject = itemArr;
      }
    }
    var customTypeFitSmart = jQuery.grep(fitsmartObject, function( n, i ) {
      return (n.designType != 'READY_TO_WEAR' && n.fitSmartType == 'CUSTOM');
    });
    if(customTypeFitSmart.length > 0){
      if(bodyType == ""){
        bodyType = customTypeFitSmart[0]['_Body Type?'];
      }
      if(height == ""){
        height = customTypeFitSmart[0]['_Height?'];
      }
      if(hipClass == ""){
        hipClass = customTypeFitSmart[0]['_Hip?'];
      }
    }
    // Start - Update value of profile data in localstorage
    jQuery.each(fitsmartObject, function(index, item) {
      if(designType != 'READY_TO_WEAR'){
        if(fitsmartObject[index]['designType'] == 'READY_TO_WEAR'){
          fitsmartObject[index]['_Body Type?'] = "NA";
          fitsmartObject[index]['_Height?'] = "NA";
          fitsmartObject[index]['_Hip?'] = "NA";
        }else{
          console.log("bodyType",bodyType);
          console.log("fitsmartObject[index]['designType']",fitsmartObject[index]['designType']);
          fitsmartObject[index]['_Body Type?'] = bodyType;
          fitsmartObject[index]['_Height?'] = height;
          fitsmartObject[index]['_Hip?'] = hipClass;
        }
      }
    });
    console.log("fitsmartObject", fitsmartObject);
    console.log('pdpType_low',pdpType_low)
    var JacketGetLocalData = jQuery.grep(fitsmartObject, function( n, i ) {
      return (n.category != pdpType_low);
    });
    var getLocalData = jQuery.grep(fitsmartObject, function( n, i ) {
      return (n.category == pdpType_low && n.designType == designType);
    });
    console.log('getLocalData',getLocalData);
    console.log('JacketGetLocalData',JacketGetLocalData);
    if(getLocalData.length > 0){
      if(getLocalData[0].category == 'shirt'){
        let sizeTableN = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
        var st_sizeN = getLocalData[0]['_Shirt Size?'];
        var newSize = sizeTableN[st_sizeN];
        console.log('newSize',newSize);
        var dataN = $.grep(fitsmartObject, function(e){
          return (e.designType != 'CUSTOM_DESIGN');
        });
        console.log(dataN,'dataN');
      }
      if(getLocalData[0].category == 'jackets'){
        var jk_sizeN = getLocalData[0]['_Size?'];
        console.log("jk_sizeN",jk_sizeN);
        var jacketsdataN = $.grep(fitsmartObject, function(e){
          return e.category != 'jackets';
        });
      }
      if(getLocalData[0].category == 'suit blazer'){
        var suitblazer_sizeN = getLocalData[0]['_Size?'];
        console.log("suitblazer_sizeN",suitblazer_sizeN);
        var suitblazerdataN = $.grep(fitsmartObject, function(e){
          return e.category != 'SUIT_BLAZER';
        });
      }
      if(getLocalData[0].category == 'long jackets'){
        var lgjk_sizeN = getLocalData[0]['_Size?'];
        console.log("lgjk_sizeN",lgjk_sizeN);
        var longjacketsdataN = $.grep(fitsmartObject, function(e){
          return e.category != 'LONG_JACKETS';
        });
      }
    }
    if(templateType == 'template-bsc'){
      console.log("shirtSize",shirtSize);
      if(newSize > 46){
        shirtSize = 'xxl';
      }
      var obj = {"category": "shirt","_Body Type?": bodyType,"_Shirt Size?": shirtSize,"_Shoulder Type?":shoulderType,"_Height?" : height,"_Preferred Fit?":preferredFit,"_Hip?":hipClass,"getsize":shirtSize,"designType":designType,fitSmartType:fitSmartType}
      fitsmartObject.push(obj);
      console.log("obj",obj);
      const key = 'designType';
      const unique = (arr, props = []) => [...new Map(arr.map(entry => [props.map(k => entry[k]).join('|'), entry])).values()];
      const arrayUniqueByKey = unique(fitsmartObject, ['category', 'designType']);
      console.log(arrayUniqueByKey,'newarr');
      localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));

    }else if(templateType == 'template-semi-stitched'){
      var obj = {"category": pdpType_low,"_Body Type?": bodyType,"_Height?" : height,"_Hip?":hipClass,"_Size?": subSize,"_Preferred Fit?":preferredFit,"_Silhouette?": silhouetteData,"getsize": subSize,"designType":designType,fitSmartType:fitSmartType}
      fitsmartObject.push(obj);
      console.log("fitsmartObject>>>>>>",fitsmartObject);
      const key = 'category';
      const dType = 'designType';
      const unique = (arr, props = []) => [...new Map(arr.map(entry => [props.map(k => entry[k]).join('|'), entry])).values()];
      const arrayUniqueByKey = unique(fitsmartObject, ['category', 'designType']);
      console.log('arrayUniqueByKey',arrayUniqueByKey);  
      if(bodyType == 'healthy'){
        if(preferredFit == "Slim" || jk_sizeN < 40 ){
          if(JacketGetLocalData.length == 0){
            console.log('remove1');
            $('[data-fitsmart-questions-main] .ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Slim"]').closest('.Property__Field').removeClass('hide');
            $('[data-fitsmart-questions-main] .ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Structured"]').closest('.Property__Field').removeClass('hide');
            $('[data-fitsmart-questions-main] .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="36"]').closest('.Property__Field').removeClass('hide');
            $('[data-fitsmart-questions-main] .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="38"]').closest('.Property__Field').removeClass('hide');
            $('[data-fitsmart-questions-main] .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="40"]').closest('.Property__Field').removeClass('hide');
            $('[data-fitsmart-questions-main] .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="42"]').closest('.Property__Field').removeClass('hide');
            $('[data-fitsmart-questions-main] .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="44"]').closest('.Property__Field').removeClass('hide');
            $('[data-fitsmart-questions-main] .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="46"]').closest('.Property__Field').removeClass('hide');
            $('[data-fitsmart-questions-main] .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="48"]').closest('.Property__Field').removeClass('hide');
            $('[data-fitsmart-questions-main] .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="50"]').closest('.Property__Field').removeClass('hide');
          }
          else{
            localStorage.setItem("fitsmartobjNew", JSON.stringify(JacketGetLocalData)); 
          }
        }else{
          localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));
        }
      }else if(bodyType == 'average'){
        localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));
      }else{
        localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));
      }
    }
    else if(templateType == 'template-rtw'){
      console.log("test RTW pdpType_low",pdpType_low);
      var shirtSize = $('.SizeSwatch__Radio:checked[name="properties[_size]"]').val();
      var obj = {"category": pdpType_low,"_Body Type?": "NA","_Height?" : "NA","_Hip?":"NA","_Shirt Size?": shirtSize,"_Preferred Fit?":"NA","_Silhouette?": "NA","getsize": shirtSize,"designType":designType}
      fitsmartObject.push(obj);
      const key = 'designType';
      const unique = (arr, props = []) => [...new Map(arr.map(entry => [props.map(k => entry[k]).join('|'), entry])).values()];
      const arrayUniqueByKey = unique(fitsmartObject, ['category', 'designType']);
      console.log(arrayUniqueByKey,'newarr');
      localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));
    }
    var getnullSize = jQuery.grep(fitsmartObject, function( n, i ) {
      // return (typeof n.getsize == 'undefined' && n.category != 'bsc');
      return ((typeof n.getsize == 'undefined' && n.category != 'bsc') || (n.getsize == 'NA' && n.category != 'bsc'));
    });
    console.log('getnullSize',getnullSize);
    if(getnullSize.length > 0){
      var updatefit = [];
      fitsmartObject.forEach(item => {
        if(item.category == getnullSize[0]['category'] && item.designType == getnullSize[0]['designType']){}
        else{
          updatefit.push(item);
        }
      });      
      console.log("updatefit",updatefit);
      if(updatefit.length > 0){
        localStorage.setItem("fitsmartobjNew", JSON.stringify(updatefit));
      }else{
        console.log('remove2');
        localStorage.removeItem("fitsmartobjNew", JSON.stringify(updatefit));
      }
    }
    manageProductFitsmartModule(templateType,pdpType_low,designType);    
    // Start -animation stop
    setTimeout(function(){
      // $('.scan-success-loader img').hide();
      toggleBodyScanGif(false);
      var animationBlastTick = document.getElementById("animation_blast_tick");
      if(animationBlastTick){
        console.log('animationBlastTick',animationBlastTick)
        $('#animation_only_Scan,.scan_text').hide();
        $('#animation_blast_tick,.blast_text').show();
        animationBlastTick.play();
      }
    },2000);
    
    if(templateType != 'template-rtw'){
      var animationBlastTick = document.getElementById("animation_blast_tick");
      if(animationBlastTick){
      animationBlastTick.addEventListener("loop", (e) => {
        console.log('stop blast tick');
        animationBlastTick.stop();
        $('body').removeClass('showAnimation');
        $('#animation_only_Scan,.scan_text').show();
        $('#animation_blast_tick,.blast_text').hide();
      });
      }
    }
    // End -animation stop
  } // setloaclstorage function
  // END -- setLocalStoreData

  function createMeasurement1(data1, isWebview = "no"){
    console.log("createMeasurement1>>>>>>>>");
    console.log('createdata',data1);
    let createMeasureOBJ = {
      "customerIdentifier": fitsmartCustomerId,
      "shopifyId": fitsmartCustomerId,
      "email": email,
      // "metadata": customerMetaKey,
      "requests": data1
    }
    console.log("createMeasureOBJ",createMeasureOBJ);
    console.log(data1.length);
    console.log(`${baseUrlBsc}`);
    var response;
    var customRequestToken = requestToken;
    customRequestToken.metadata = customerMetaKey;
    $.ajax({
      url: baseUrlBsc+ '/sizing/v4/createMeasurmentShopify',
      type: 'POST',
      data: JSON.stringify(createMeasureOBJ),
      contentType: "application/json",
      dataType: "json",
      headers: customRequestToken,
      success: function(data, xhr) {
        response = data;
        console.log('create measure success',data,"xhr",xhr);
        console.log("isWebview",isWebview);
        if(isWebview == "yes" && document.body.classList.contains("temp_webview")){
          setTimeout(() => {
            const addToCartParams = {"appmakerAction": {"action": "SWITCH_TO_STANDARD"}}
            sendMessageToApp(addToCartParams);
          },200);
        }
        // $('.scan-success-loader img').hide();
        toggleBodyScanGif(false);
        $('#animation_only_Scan,.scan_text').hide();
        setTimeout(function(){
          var animationBlastTick = document.getElementById("animation_blast_tick");
          console.log('animationBlastTick',animationBlastTick)
          $('#animation_blast_tick,.blast_text').show();
          animationBlastTick.play();
        },500);
        createMeasurementCOUNTER = 0;
      },complete: function(xhr) {
        
        console.log("complete",response,"xhr",xhr);
        if(xhr.status == 200){
          if(response.success != null){
            console.log('fitsmartCustomerId',fitsmartCustomerId)
            asyncFlag = true;
            asyncAPI = true;
            var animationBlastTick = document.getElementById("animation_blast_tick");
            animationBlastTick.addEventListener("loop", (e) => {
              console.log('stop blast tick',e);
              animationBlastTick.stop();
              $('body').removeClass('showAnimation');
              $('#animation_only_Scan,.scan_text').show();
              $('#animation_blast_tick,.blast_text').hide();
            });
            localStorage.needToGetCustomerProfileData = true;
            getCustomerProfileAPIData(fitsmartCustomerId);
          }else{
            if(response.error.errorCode == "406" || response.error.errorCode == "500"){
              console.log("error code 406>>>",response.error);
              var fetchURL = `${window.location.href}`;
              fetch(fetchURL,{
              method:'GET', headers: {
              'Content-Type': 'application/json'}
              })
              .then((response) =>{
              return response.text();
              }).then(data =>{
                let parser = new DOMParser();
                let parsedHtml = parser.parseFromString(data, 'text/html');
                customerMetaKey = parsedHtml.querySelector('body').getAttribute("data-customer-key");
                console.log("parsedHtml",parsedHtml,"customerMetaKey",customerMetaKey);
                // debugger;
                createMeasurement1(data1, isWebview);
              });
            }
          }
        }
      },
      error: function(err) {
        console.log(err);
      }
    });
  }
 
  $(document).ready(function(){
    setTimeout(function(){
      $('.pro-nex-prev').addClass('arrowAniation');
    }, 500);
    var  boostHandleStore = localStorage.getItem("boostHandle");
    boostHandleStore = JSON.parse(boostHandleStore);
    if(boostHandleStore && boostHandleStore.length > 0){
      var prod_handle = $('body').data('product-handle');
      var currIndex =  boostHandleStore.indexOf(prod_handle);
      var prevIndex =  currIndex - 1;
      var nextIndex =  currIndex + 1;
      var prevHandle;
      var nextHandle;
      if(prevIndex >= 0){
        prevHandle = '/products/'+boostHandleStore[prevIndex];
      }else{
        prevHandle = "";
      }
      if(nextIndex <= boostHandleStore.length - 1 ){
        nextHandle = '/products/'+boostHandleStore[nextIndex];
      }else{
        nextHandle = "";
      }
      $('.customizePDP').attr('data-prevprod',prevHandle);
      $('.customizePDP').attr('data-nextprod',nextHandle);
      $('.pro-nex-prev .pro-prev').attr('href',prevHandle);
      $('.pro-nex-prev .pro-next').attr('href',nextHandle);
    }
    if($('.ProductForm').hasClass('bsc')){
      if($('.customise-box').hasClass('hide')){
        setTimeout(() => {
          $(".Product__Slideshow, .pro-nex-prev").on('swiped', function(e){
            var swapRigth =  $('.customizePDP').attr('data-prevprod');
            var swapLeft = $('.customizePDP').attr('data-nextprod');
            if(swapRigth){
              if (e.detail.dir == 'right'){
                window.location.href = swapRigth;
                $('body').addClass('movedRight');
              }
            }
            if(swapLeft){
              if (e.detail.dir == 'left'){
                window.location.href = swapLeft;
                $('body').addClass('movedLeft');
              }
            }
          });
        },3000);
      }
    }else{
      setTimeout(() => {
        $(".Product__Slideshow, .pro-nex-prev").on('swiped', function(e) {
          var swapRigth =  $('.customizePDP').attr('data-prevprod');
          var swapLeft = $('.customizePDP').attr('data-nextprod');
          if(swapRigth){
            if (e.detail.dir == 'right'){
              window.location.href = swapRigth;
              $('body').addClass('movedRight');
            }
          }
          if(swapLeft){
            if (e.detail.dir == 'left'){
              window.location.href = swapLeft;
              $('body').addClass('movedLeft');
            }
          }
        });
      },3000);
    }
    // $('body').on('click', '.similar-product', function(event){
    //   $('body').addClass('pdp-similar-product');
    // });
    // $('.close_similarView').click(function(){
    //   $('body').removeClass('pdp-similar-product');
    // });
    $('body').on('click', '.meta_colors', function(event){
      $('body').addClass('pdp-metacolor');
    });
    $('.new-color-varient .varient-title .hide-close, .cityof_varient_overlay').click(function(){
      $('body').removeClass('pdp-metacolor');
    });
    var prev = $('.customizePDP').attr('data-prevprod');
    var next = $('.customizePDP').attr('data-nextprod');
    $('.pro-nex-prev').removeClass('hide');
    if(prev !== ""){
      $('.pro-prev').removeClass('hide');
    }else{
      $('.pro-prev').addClass('hide');
    }
    if(next !== ""){
      $('.pro-next').removeClass('hide');
    }else{
      $('.pro-next').addClass('hide');
    }
    if((prev !== "" || next !== "") && !$('.ProductForm').hasClass('giftcard')){
      $(window).scroll(function(){
        if($('.ProductForm').hasClass('bsc')){
          if($('.customise-box').hasClass('hide')){
            if($('.main_pgp_image:last-child').length > 0){
              var lastImg = $('.main_pgp_image:last-child').offset().top;
              var lastImg_ = lastImg - 500;
              var scroll = $(window).scrollTop();
              var height = $(window).height();
              if(lastImg < scroll){
                $('.pro-nex-prev').addClass('hide');
              }else{
                $('.pro-nex-prev').removeClass('hide');
              }
            }
          }else{
            $('.pro-nex-prev').addClass('hide');
          }
        }else{
          if($('body').hasClass('open_semicustom')){
            $('.pro-nex-prev').addClass('hide');
          }else{
            if($('.main_pgp_image:last-child').length > 0){
              var lastImg = $('.main_pgp_image:last-child').offset().top;
              var lastImg_ = lastImg - 500;
              var scroll = $(window).scrollTop();
              var height = $(window).height();
              if(lastImg < scroll){
                $('.pro-nex-prev').addClass('hide');
              }else{
                $('.pro-nex-prev').removeClass('hide');
              }
            }
          }
        }
      });
    }
  });
  // document ready -- end
// }
// END -- window.productInfo && $('.template-product').length > 0){


/*
=================================================
Fitsmart popup overlay click event ======> start
=================================================
*/

/*
=================================================
Fitsmart popup overlay click event ======> end
=================================================
*/


/*
=================================================
Product page - Shopped with US ? ======> start
=================================================
*/

$(document).on("click","[data-show-shopped-with-us-popup-btn]",function(e){
  e.preventDefault();
  console.log("addCustomSize clicked");
  var fitsmartOBJ = localStorage.getItem("fitsmartobjNew");
  fitsmartOBJ = JSON.parse(fitsmartOBJ);
  var customiseFitsmartOBJ = [];
  if(fitsmartOBJ != null && fitsmartOBJ.length > 0){
    customiseFitsmartOBJ = jQuery.grep(fitsmartOBJ, function(n,i){
      return (n.designType != 'READY_TO_WEAR' && n.fitSmartType != "STANDARD");
    });
  }
  if(customiseFitsmartOBJ.length == 0){
    document.body.classList.add("shopped-us-popup");
    console.log("shopped-us-popup");
    
  }else{
    
    document.body.classList.add("fitsmart-popup");
  }
  document.querySelector(".pro-customise-design-toast-msg")?.classList.add("hide");
});

$(document).on("click","[data-shopped-with-us] .shopped-with-us-main-close, .shopped-with-us-main-overlay",function(e){
  e.preventDefault();
  document.body.classList.remove("shopped-us-popup");
});

$(document).on("click","[data-btn-login-now]",function(e){
  e.preventDefault();
  console.log("loginNowBtn clicked");
  document.body.classList.remove("shopped-us-popup");
  document.body.classList.add("shop-before-login");
});

$(document).on("click","[data-btn-show-size-drawer]",function(e){
  e.preventDefault();
  console.log("sizeMeUpBtn clicked");
  document.body.classList.add("fitsmart-popup");
  document.body.classList.remove("shopped-us-popup");
});

$(document).on("click","[data-close-fitsmart-popup]",function(e){
  e.preventDefault();
  console.log("fitsmartDrawerClose clicked");
  // webview close drawer action
  if(document.body.classList.contains("temp_webview")){
    const closeActionParams = {
        "appmakerAction": {
            "action": "CLOSE_MODAL",
            "params": {}
        }
    }
    sendMessageToApp(closeActionParams);
  }else{
    document.body.classList.remove("shopped-us-popup");
    document.body.classList.remove("fitsmart-popup");
  }
});

$(document).on("click","[data-close-shop-before-login-popup], body.shop-before-login .product-fitsmart-overlay",function(e){
  e.preventDefault();
  console.log("Shop before login close btn clicked");
  document.body.classList.remove("shop-before-login");
});

// $(document).on("click","[data-add-custom-size-btn]",function(e){
//   e.preventDefault();
//   console.log("editCustomSize clicked");
//   document.body.classList.add("fitsmart-popup");
//   document.querySelector(".pro-customise-design-toast-msg")?.classList.add("hide");

//   const btn = document.querySelector('[data-add-custom-size-btn]');
//   const video = document.getElementById('fitsmartlazyVideo');

//   if (!btn || !video) return;

//     // prevent duplicate source
//     if (video.querySelector('source')) return;
//     if (!video.getAttribute('poster')) {
//       video.poster = "https://cdn.shopify.com/s/files/1/0536/3594/0515/files/Fitsmart_-_Master_Thumbnail_wo_logo_1.jpg?v=1733390531"
//     }
//     const source = document.createElement('source');
//     source.src = 'https://cdn.shopify.com/videos/c/o/v/8013b381ddc447b09880bdda60d6811a.mp4';
//     source.type = 'video/mp4';

//     video.appendChild(source);
//     video.load();

//     // optional autoplay
//     // video.play().catch(() => {});

// });

function loadFitSmartVideo() {
  const video = document.getElementById('fitsmartlazyVideo');
  if (!video) return;
  // prevent duplicate source
  if (video.querySelector('source')) return;

  if (!video.getAttribute('poster')) {
    video.poster =
      "https://cdn.shopify.com/s/files/1/0536/3594/0515/files/Fitsmart_-_Master_Thumbnail_wo_logo_1.jpg?v=1733390531";
  }

  const source = document.createElement('source');
  source.src =
    "https://cdn.shopify.com/videos/c/o/v/8013b381ddc447b09880bdda60d6811a.mp4";
  source.type = "video/mp4";

  video.appendChild(source);
  video.load();

  // optional autoplay
  // video.play().catch(() => {});
}
$(document).on("click","[data-add-custom-size-btn]",function(e){
  // e.preventDefault();
  console.log("test");
  
  document.body.classList.add("fitsmart-popup")
  loadFitSmartVideo();
})
document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("fitsmart-popup")) {
    loadFitSmartVideo();
  }
});

/*
=================================================
Product page - Shopped with US ? ======> end
=================================================
*/

// switch to standard confirm popup -- start
$(document).on("click","[data-switch-to-standard-confirm-btn]",function(e){
  e.preventDefault();
  console.log("switchToStandardConfirm clicked");
  document.body.classList.add("switch-to-standard-confirm-popup");
});
// switch to standard confirm popup -- end

// switch to standard reconfirm popup -- cancel btn -- [data-reconfirm-switch-to-standard-cancel]
$(document).on("click","[data-reconfirm-switch-to-standard-cancel]",function(e){
  e.preventDefault();
  console.log("switchToStandard_reconfirmCancel clicked");
  document.body.classList.remove("switch-to-standard-confirm-popup");
});

$(document).on("click","[data-switch-to-standard-btn]",function(e){
  e.preventDefault();
  console.log("switchToStandard clicked");
  setTimeout(() => {
    // hide -- switch to standard popup element
    document.body.classList.remove("switch-to-standard-confirm-popup");
  },500);

  if(document.body.classList.contains("logged")){
    let fitSmartObj = JSON.parse(localStorage.getprofile);
    fitSmartObj = jQuery.grep(fitSmartObj.fitProfiles, function(n,i){
      return (n.categoryName == pdpType_low && n.designType != "READY_TO_WEAR");
    });
    console.log("fitSmartObj",fitSmartObj);
    let pdpCat = getCreateMeasurementCategory(pdpType_low);     
    
    let fitSmartProfiles = JSON.parse(localStorage.getprofile).fitProfiles;

    const compareDesignType = designType === "SEMI_STITCHED" ? "CUSTOM_DESIGN" : designType;

      // profile.designType === designType

    let matchedFitSmart = fitSmartProfiles.find(profile =>
      profile.categoryName?.toLowerCase() === pdpType_low?.toLowerCase() &&
      profile.designType === compareDesignType
    );

      if (pdpCat == "Long Jackets") {
        pdpCat = "LONG_JACKETS"
      } else if (pdpCat == "Relaxed Neapolitan Pants") {
        pdpCat = "RELAXED_NEAPOLITAN_PANTS"
      } 
    var bscArr = [];

        if(pdpCat == 'DRESS_PANTS' && designType == "HEMMING"){
        var bscData = {
          "gender": "Male",
          "category": pdpCat,
          "fit": "NA",
          "brand": "BOM",
          "designType": designType,
          "type":"STANDARD",
          "fitSmart": {
          "stdSize": matchedFitSmart.fitsmart.stdSize?.value
          }
        }
    } else if (pdpCat == 'DRESS_PANTS' && designType == "SEMI_STITCHED") {
        var bscData = {
          "gender": "Male",
          "category": pdpCat,
          "fit": "NA",
          "brand": "BOM",
          "designType": designType,
          "type":"STANDARD",
          "fitSmart": {
          "stdSize": matchedFitSmart.fitsmart.stdSize?.value
          }
        }
    } else {
      var bscData = {
        "gender": "Male",
        "category": pdpCat,
        "fit": "NA",
        "brand": "BOM",
        "designType": designType,
        "type":"STANDARD",
        "fitSmart": {
        "stdSize": fitSmartObj[0].fitsmart.stdSize.value
        }
      }
    }
    if(pdpCat == 'NEAPOLITAN_DRESS_PANTS' || pdpCat == 'SMARTPANTS' || pdpCat == 'LINEN_PANTS' || pdpCat == 'TShirts'){
      delete bscData.designType;
    }
    if(pdpCat == 'Chinos' || pdpCat == 'NEAPOLITAN_DRESS_PANTS'){
      bscData["silhouette"] = "NA";
    }
    if(pdpCat == 'DRESS_PANTS' && designType == "HEMMING"){
        bscData["silhouette"] = "NA";
    } else if (pdpCat == 'DRESS_PANTS' && designType == "SEMI_STITCHED") {
        bscData["silhouette"] = fitSmartObj[0].silhouette.value ? fitSmartObj[0].silhouette.value : "Straight";
    }
    bscArr.push(bscData);
    console.log("switch to standard createMeasurement");
    if(document.body.classList.contains("temp_webview")){
      createMeasurement1(bscArr,"yes");
    }else{
      setTimeout(() => {
        createMeasurement1(bscArr);
        document.body.classList.remove("fitsmart-popup");
      }, 500);
    }
    console.log("847");
    $('[data-standard-rec-size]').html(`${matchedFitSmart.fitsmart.stdSize.value}`).parents(".standard-rec-size-content").removeClass("hide");      
  }else{
    // not logged in - as a guest
    let fitSmartObj = JSON.parse(localStorage.fitsmartobjNew);
    fitSmartObj = jQuery.grep(fitSmartObj, function(n,i){
      return (n.category == pdpType_low && n.designType != "READY_TO_WEAR");
    });

    const matchedFitSmart = fitSmartObj.find(item =>
      item.category?.toLowerCase() === pdpType_low?.toLowerCase() &&
      item.designType?.toLowerCase() === designType?.toLowerCase()
    );
    console.log("matchedFitSmart",matchedFitSmart);
    
    console.log("fitSmartObj",fitSmartObj,fitSmartObj[0].getsize);
    let fitSmartType = "STANDARD";
    if(pdpType_low == "shirt"){
      setLocalStoreData(fitSmartObj[0]["_Body Type?"],fitSmartObj[0]["_Hip?"],fitSmartObj[0]["_Height?"],fitSmartObj[0].getsize,"","",fitSmartObj[0].getsize,"",pdpType_low,designType,fitSmartType);
    }else if (pdpType_low == "dress pants") {
      setLocalStoreData(matchedFitSmart["_Body Type?"],matchedFitSmart["_Hip?"],matchedFitSmart["_Height?"],matchedFitSmart.getsize.toUpperCase(),"","",matchedFitSmart.getsize.toUpperCase(),"",pdpType_low,designType,fitSmartType);
    }else {
      setLocalStoreData(fitSmartObj[0]["_Body Type?"],fitSmartObj[0]["_Hip?"],fitSmartObj[0]["_Height?"],fitSmartObj[0].getsize.toUpperCase(),"","",fitSmartObj[0].getsize.toUpperCase(),"",pdpType_low,designType,fitSmartType);
    }

    document.body.classList.remove("fitsmart-popup");
    if (pdpType_low == "dress pants") {
      if(document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${matchedFitSmart.getsize.toLowerCase()}"]`)) document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${matchedFitSmart.getsize.toLowerCase()}"]`).click();
    } else {
      if(document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${fitSmartObj[0].getsize.toLowerCase()}"]`)) document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${fitSmartObj[0].getsize.toLowerCase()}"]`).click();
    }
  }
});

/*
=================================================
Product page - STANDARD SIZE radio change ======> start
=================================================
*/

$(document).on("change","[data-pro-standard-size-main] input[type='radio']",function(e){
  e.preventDefault();
  console.log("standard size change",$(this).val());
  let thisVal = $(this).val();
  if(pdpType_low == "relaxed t-shirts" || pdpType_low == "t-shirts" || pdpType_low == "oversized t-shirts" || pdpType_low == "long sleeve polo t-shirts"){
    thisVal = thisVal.toUpperCase();
  }
  let sizeSwatch = document.querySelector('.ProductForm__Variants .SizeSwatchList li [type="radio"][value="'+thisVal+'"]');
  console.log("sizeSwatch",sizeSwatch);
  if (document.body.classList.contains("temp_suit-product")) {
    if(sizeSwatch) handlePDPquickView($(this).attr("data-variant"));
  }else if(document.body.classList.contains("template-product")){
    if(sizeSwatch) sizeSwatch.click();
  }else{
    if(sizeSwatch) handlePDPquickView($(this).attr("data-variant"));
  }
  $(".pro-select-standard-size-toast-msg, .pro-customise-design-toast-msg").addClass("hide");
  $(`[data-pro-fitsmart-type-input]`).val("STANDARD");
});

/*
=================================================
Product page - STANDARD SIZE radio change ======> end
=================================================
*/

/*
=================================================
RTW ======> start
=================================================
*/
function manageProductsRTW(){
if(templateType == 'template-rtw'){

  $(document).on('click','.ProductForm.rtw .ProductForm__AddToCart',function(){
    $(this).addClass("btn_notclick");
    
    if($('.notlogged').length > 0){
      var subSize = $('.SizeSwatch__Radio:checked[name="properties[_size]"]').val();
      console.log(subSize ,"subSize");
      console.log(pdpType_low,"pdpType_low");
      if(subSize != 'undefined'){
        // $('.rtw-rec-size').html('size <span>'+ subSize +'</span> Recommended');
        $('.rtw-rec-size').html('Your last Selected Size : <span>'+ subSize +'</span>');
        $(".rtw-size-header").removeClass("hide");
      }
      setLocalStoreData("","","",subSize,"","",subSize,"",pdpType_low,designType,"");
      // console.log(setLocalStoreData,"setLocalStoreData");
      // debugger;
    }else{
      var shirtSizelg = $('.SizeSwatchList input[type="radio"][name="properties[_size]"]:checked').val();
      let pdpCat = "Shirts";
      if(pdpType_low == "jackets"){
        pdpCat = "Jackets";
      }else if(pdpType_low == "long jackets"){
        pdpCat = "LONG_JACKETS";
        shirtSizelg = shirtSizelg.toLocaleLowerCase();
      }else if(pdpType_low == "soft tailored jackets"){
        pdpCat = "SOFT_TAILORED_JACKETS";
        shirtSizelg = shirtSizelg.toLocaleLowerCase();
      }else if(pdpType_low == "sweatshirts"){
        pdpCat = "Sweatshirts";
        shirtSizelg = shirtSizelg.toLocaleLowerCase();
      }else if(pdpType_low == "sweaters"){
        pdpCat = "Sweaters";
        shirtSizelg = shirtSizelg.toLocaleLowerCase();
      }else if(pdpType_low == "shackets"){
        pdpCat = "SHACKETS";
      }else if(pdpType_low == "joggers"){
        pdpCat = "Joggers";
        shirtSizelg = shirtSizelg.toLocaleLowerCase();
      }else if(pdpType_low.includes("shorts")){
        pdpCat = pdpType_low.replace(" ","_").toUpperCase();
        shirtSizelg = shirtSizelg.toLocaleLowerCase();
      }
      var bscArr = [];
      var bscData = {
        "gender": "Male",
        "category": pdpCat,
        "fit": "NA",
        "brand": "BOM",
        "designType": designType,
        "fitSmart": {
          "stdSize": shirtSizelg
        }
      }
      bscArr.push(bscData);         
      setTimeout(() => {
        console.log("RTW A2C createMeasurement");
        createMeasurement1(bscArr);
      }, 500);
      if(shirtSizelg != 'undefined'){
        // $('.rtw-rec-size').html('size <span>'+ shirtSizelg +'</span> Recommended');
        $('.rtw-rec-size').html('Your last Selected Size : <span>'+ shirtSizelg +'</span>');
        $(".rtw-size-header").removeClass("hide");
      }
    }
  });
  if(document.body.classList.contains("logged")){
    profileAPIData = localStorage.getItem("getprofile");
    profileAPIData = JSON.parse(profileAPIData);
    console.log("profileAPIData",profileAPIData);
    if(profileAPIData != null){
      console.log("profileAPIData.fitProfiles",profileAPIData.fitProfiles);
      var profileDataAPI = jQuery.grep(profileAPIData.fitProfiles, function( n, i ) {
        return (n.categoryName == pdpType_low && n.designType == "READY_TO_WEAR" ) ;
      });
      console.log("profileDataAPI",profileDataAPI);
      if(profileDataAPI.length > 0){
        console.log("size",profileDataAPI[0].fitsmart.stdSize?.value);
        var sizeselect = profileDataAPI[0].fitsmart.stdSize?.value;
        if(sizeselect){
          // $('.rtw-rec-size').html('size <span>'+ sizeselect +'</span> Recommended');
          $('.rtw-rec-size').html('Your last Selected Size : <span>'+ sizeselect +'</span>');
          $(".rtw-size-header").removeClass("hide");
        }
        if(profileDataAPI[0].fitsmart.stdSize?.value && location.href.includes("editCustomisations") != true){
          if(pdpType_low == 'sweatshirts' || pdpType_low == 'sweaters' || pdpType_low == 'joggers' || pdpType_low.includes("shorts")){
            if(document.querySelector(`.SizeSwatchList input[type="radio"][value="${profileDataAPI[0].fitsmart.stdSize.value.toUpperCase()}"]`)) document.querySelector(`.SizeSwatchList input[type="radio"][value="${profileDataAPI[0].fitsmart.stdSize.value.toUpperCase()}"]`).click();
          }else{
            if(document.querySelector(`.SizeSwatchList input[type="radio"][value="${profileDataAPI[0].fitsmart.stdSize.value}"]`)) document.querySelector(`.SizeSwatchList input[type="radio"][value="${profileDataAPI[0].fitsmart.stdSize.value}"]`).click();
          }
        }
      }
    }
  }
  
  // if(window.location.href.includes("#modal") || window.location.href.includes("itemid") || window.location.href.includes("customisable")){
  //   if(document.querySelector("[data-btn-wrap] .rtw_sele_size")) document.querySelector("[data-btn-wrap] .rtw_sele_size").classList.add("hide");
  //   document.querySelector(".rtw-mobile-slide").classList.remove("hide");
  //   if(document.querySelector(".ProductForm__AddToCart")) document.querySelector(".ProductForm__AddToCart").classList.remove("hide","hidden-phone");
  //   document.body.classList.add("show-rtw-details");
  // }
  // rtw - select size btn click event
  $(document).on("click","[data-btn-wrap] .rtw_sele_size",function(e){
    e.preventDefault();
    if(document.querySelector(".rtw-mobile-slide")){
      document.querySelector(".rtw-mobile-slide").classList.remove("hide");
      if(document.querySelector(".ProductForm__AddToCart")) document.querySelector(".ProductForm__AddToCart").classList.remove("hide","hidden-phone");
      // $(this).addClass("hide");
      this.classList.add("hide");
      if (window.innerWidth <= 1007){
        document.body.classList.add("show-rtw-details");
      }
    }
  });
  //rtw-mobile-dr
  $(document).on("click","[data-rtw-mobile-drawer-close-btn]",function(e){
    e.preventDefault();
    document.body.classList.remove("show-rtw-details");
    if(document.querySelector("[data-btn-wrap] .rtw_sele_size")) document.querySelector("[data-btn-wrap] .rtw_sele_size").classList.remove("hide");
    if(document.querySelector(".ProductForm__AddToCart")) document.querySelector(".ProductForm__AddToCart").classList.add("hide","hidden-phone");
  });
}
}
manageProductsRTW();
/*
=================================================
RTW ======> end
=================================================
*/

/*
=================================================
NEW FITSMART MODULE ======> start
=================================================
*/

// edit-fitsmart-popup-open -- EDIT PROFILES - EDIT SIZES
$(document).on("click","[data-edit-fitsmart-popup-open]",function(e){
  e.preventDefault();
  console.log("edit fitsmart btn clicked");
  if($(this).attr("data-btn-type") == "edit-profiles"){
    $("[data-edit-profile-ele]").removeClass("hide");
    $("[data-edit-size-ele]").addClass("hide");
  }else{
    $("[data-edit-profile-ele]").addClass("hide");
    $("[data-edit-size-ele]").removeClass("hide");
  }
  document.body.classList.add("fitsmart-edit");
});

// data-edit-fitsmart-close -- EDIT FITSMART POPUP CLOSE
$(document).on("click","[data-edit-fitsmart-close], body.fitsmart-edit:not(.fitsmart-edit-confirm):not(.fitsmart-sizechart) .product-fitsmart-overlay",function(e){
  e.preventDefault();
  console.log("edit fitsmart close popup btn clicked");
  document.body.classList.remove("fitsmart-edit");
});

// edit profile radio change
$(document).on('click','[data-edit-profile-ele] .ProductSize__Elements [type="radio"]',function(){
  console.log("edit profile input change");
  if(document.body.classList.contains("notlogged")){
    fitsmartObject = localStorage.getItem("fitsmartobjNew");
    fitsmartObject = JSON.parse(fitsmartObject);
    console.log('fitsmartObject==>',fitsmartObject);
    var editLineBSC = jQuery.grep(fitsmartObject, function(n,i){
      // return (n.category == pdpType_low && n.designType == designType);
      return (n.designType == "CUSTOM_DESIGN" || n.designType == "SEMI_STITCHED" || n.designType == "HEMMING");
    });
    console.log("edit category fitsmart",editLineBSC);
    var st_bType = editLineBSC[0]['_Body Type?'];
    var st_height = editLineBSC[0]['_Height?'];
    var st_hip = editLineBSC[0]['_Hip?'];

    setTimeout(() => {
      var bodyTypeData = $('[data-edit-profile-ele] [name="properties[_Body Type?]"].activeradio').val();
      var heigthData = $('[data-edit-profile-ele] [name="properties[_Height?]"].activeradio').val();
      var hip = $('[data-edit-profile-ele] [name="properties[_Hip?]"].activeradio').val();
      var imageArray = {'bodyType':st_bType,'height':st_height,'hip':st_hip};
      var currArray = {'bodyType':bodyTypeData,'height':heigthData,'hip':hip};
      console.log("imageArray",imageArray);
      console.log("currArray",currArray);
      if(JSON.stringify(imageArray) === JSON.stringify(currArray)){
        $('[data-save-changes-btn]').addClass('disabled');
      }else{
        $('[data-save-changes-btn]').removeClass('disabled');
      }
    },200);
  }else{
    var fitsmartProfileAPI_obj = localStorage.getItem("getprofile");
    fitsmartProfiles = JSON.parse(fitsmartProfileAPI_obj)?.fitProfiles;
    profileFitsmart = JSON.parse(fitsmartProfileAPI_obj)?.profileFitsmart;
    console.log('fitsmartProfiles',fitsmartProfiles,"profileFitsmart",profileFitsmart);
    if(pdpType_low == 'jackets' || pdpType_low == 'suit blazer' || pdpType_low == 'long jackets' || pdpType_low == 'shirt'){
      var editLineBSC = jQuery.grep(fitsmartProfiles, function(n,i){
        return (n.categoryName == pdpType_low && n.designType == designType);
      });
    }else{
      var editLineBSC = jQuery.grep(fitsmartProfiles, function(n,i){
        return (n.categoryName == pdpType_low);
      });
    }
    console.log("edit category fitsmart",editLineBSC);
    var st_bType = profileFitsmart.bodyShape;
    var st_height = profileFitsmart.height;
    var st_hip = profileFitsmart.hipClass;

    setTimeout(() => {
      var bodyTypeData = $('[data-edit-profile-ele] [name="properties[_Body Type?]"].activeradio').val();
      var heigthData = $('[data-edit-profile-ele] [name="properties[_Height?]"].activeradio').val();
      var hip = $('[data-edit-profile-ele] [name="properties[_Hip?]"].activeradio').val();
      var imageArray = {'bodyType':st_bType,'height':st_height,'hip':st_hip};
      var currArray = {'bodyType':bodyTypeData,'height':heigthData,'hip':hip};
      console.log("imageArray",imageArray);
      console.log("currArray",currArray);
      if(JSON.stringify(imageArray) === JSON.stringify(currArray)){
        $('[data-save-changes-btn]').addClass('disabled');
      }else{
        $('[data-save-changes-btn]').removeClass('disabled');
      }
    },200);
  }
});
// End - Button status change, when element change

// edit sizes radio change
$(document).on('click','[data-edit-size-ele] .ProductSize__Elements [type="radio"]',function(){
  console.log("edit sizes input change");
  if(document.body.classList.contains("notlogged")){
    fitsmartObject = localStorage.getItem("fitsmartobjNew");
    fitsmartObject = JSON.parse(fitsmartObject);
    console.log('fitsmartObject==>',fitsmartObject);
    var editLineBSC = jQuery.grep(fitsmartObject, function(n,i){
      return (n.category == pdpType_low && n.designType == designType);
    });
    console.log("edit category fitsmart",editLineBSC);
    var fs_shirtSize = editLineBSC[0]['_Shirt Size?'] ? editLineBSC[0]['_Shirt Size?'] : "NA";
    var fs_shoulderType = editLineBSC[0]['_Shoulder Type?'] ? editLineBSC[0]['_Shoulder Type?'] : "NA";
    var fs_preferredFit = editLineBSC[0]['_Preferred Fit?'] ? editLineBSC[0]['_Preferred Fit?'] : "NA";
    var fs_size = editLineBSC[0]['_Size?'] ? editLineBSC[0]['_Size?'] : "NA";
    var fs_silhouette = editLineBSC[0]['_Silhouette?'] ? editLineBSC[0]['_Silhouette?'] : "NA";
    setTimeout(() => {
      var shirtSize = $('[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio').val() : "NA";
      var shoulderType = $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio').val() : "NA";
      var preferredFit = $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio').val() : "NA";
      var size = $('[data-edit-size-ele] [name="properties[_Size?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Size?]"].activeradio').val() : "NA";
      var silhouette = $('[data-edit-size-ele] [name="properties[_Silhouette?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Silhouette?]"].activeradio').val() : "NA";
      var imageArray = {'shirtSize':fs_shirtSize,'shoulderType':fs_shoulderType,'preferredFit':fs_preferredFit,size:fs_size,silhouette:fs_silhouette};
      var currArray = {'shirtSize':shirtSize,'shoulderType':shoulderType,'preferredFit':preferredFit,size:size,silhouette:silhouette};
      console.log("imageArray",imageArray);
      console.log("currArray",currArray);
      if(JSON.stringify(imageArray) === JSON.stringify(currArray)){
        $('[data-save-changes-btn]').addClass('disabled');
      }else{
        $('[data-save-changes-btn]').removeClass('disabled');
      }
    },200);
  }else{ // loggedin view
    var fitsmartProfileAPI_obj = localStorage.getItem("getprofile");
    fitsmartProfiles = JSON.parse(fitsmartProfileAPI_obj)?.fitProfiles;
    profileFitsmart = JSON.parse(fitsmartProfileAPI_obj)?.profileFitsmart;
    console.log('fitsmartProfiles',fitsmartProfiles,"profileFitsmart",profileFitsmart);
    if(pdpType_low == 'jackets' || pdpType_low == 'suit blazer' || pdpType_low == 'long jackets' || pdpType_low == 'shirt'){
      var editLineBSC = jQuery.grep(fitsmartProfiles, function(n,i){
        return (n.categoryName == pdpType_low && n.designType == designType);
      });
    }else{
      var editLineBSC = jQuery.grep(fitsmartProfiles, function(n,i){
        return (n.categoryName == pdpType_low);
      });
    }    
    console.log("edit category fitsmart",editLineBSC);
    var fs_shirtSize = editLineBSC[0].fitsmart.stdSize ? editLineBSC[0].fitsmart.stdSize.value : "NA";
    var fs_shoulderType = editLineBSC[0].fitsmart.shoulderType ? editLineBSC[0].fitsmart.shoulderType.value : "NA";
    var fs_preferredFit = editLineBSC[0].fitsmart.fit ? editLineBSC[0].fitsmart.fit.value : "NA";
    var fs_size = editLineBSC[0].fitsmart.stdSize ? editLineBSC[0].fitsmart.stdSize.value : "NA";
    var fs_silhouette = editLineBSC[0].fitsmart.silhouette ? editLineBSC[0].fitsmart.silhouette.value : "NA";
    setTimeout(() => {
      var shirtSize = $('[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio').val() : "NA";
      var shoulderType = $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio').val() : "NA";
      var preferredFit = $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio').val() : "NA";
      var size = $('[data-edit-size-ele] [name="properties[_Size?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Size?]"].activeradio').val() : "NA";
      var silhouette = $('[data-edit-size-ele] [name="properties[_Silhouette?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Silhouette?]"].activeradio').val() : "NA";
      if(editLineBSC[0].categoryName == 'shirt'){
        size = fs_size;
      }else{
        shirtSize = fs_shirtSize;
      }
      var imageArray = {'shirtSize':fs_shirtSize,'shoulderType':fs_shoulderType,'preferredFit':fs_preferredFit,size:fs_size,silhouette:fs_silhouette};
      var currArray = {'shirtSize':shirtSize,'shoulderType':shoulderType,'preferredFit':preferredFit,size:size,silhouette:silhouette};
      console.log("imageArray",imageArray);
      console.log("currArray",currArray);
      if(JSON.stringify(imageArray) === JSON.stringify(currArray)){
        $('[data-save-changes-btn]').addClass('disabled');
      }else{
        $('[data-save-changes-btn]').removeClass('disabled');
      }
    },200);
  }
});
// End - Button status change, when element change

// calculate btn CLICK event
$(document).on('click','[data-calculate-fitsmart]',function(){
  console.log("data-calculate-fitsmart btn clicked");
  if(document.querySelector('[data-pro-standard-size-main] input:checked[name="properties[_Standard Size?]"]')){
    console.log("standard size radio unchecked");
    document.querySelector('[data-pro-standard-size-main] input:checked[name="properties[_Standard Size?]"]').checked = false;
    $(`[data-pro-fitsmart-type-input]`).val("CUSTOM");
  }
  if(document.body.classList.contains("notlogged")){
    // Start-animation start
    async function asyncCall(){
      $('body').addClass('showAnimation');
      // $('.scan-success-loader img').show();
      toggleBodyScanGif(true);
    }
    // End- animation start
    asyncCall();
    fitsmartObject1 = localStorage.getItem("fitsmartobjNew");
    fitsmartObject1 = JSON.parse(thefitsmartObject);
    console.log('fitsmartObject1nira',fitsmartObject1);
    var bodyType,hipClass,height;
    if(fitsmartObject1 && fitsmartObject1.length && fitsmartObject1[0]['designType'] != 'READY_TO_WEAR' && fitsmartObject1[0]['fitSmartType'] != "STANDARD"){
       bodyType = fitsmartObject1[0]['_Body Type?'];
       hipClass = fitsmartObject1[0]['_Hip?'] != undefined ? fitsmartObject1[0]['_Hip?'] : $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Hip?]"]').val();
       height = fitsmartObject1[0]['_Height?'];
    }else{
       bodyType = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Body Type?]"]').val();
       hipClass = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Hip?]"]').val();
       height = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Height?]"]').val();
    }    
    if(templateType == 'template-bsc'){
      var shirtSize = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Shirt Size?]"]').val();
      var shoulderType = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Shoulder Type?]"]').val();
      var preferredFit = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Preferred Fit?]"]').val();
      design_type = designType;
    }else if(templateType == 'template-semi-stitched'){
      design_type = designType;
      var subSize = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Size?]"]').val();
      var preferredFit = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Preferred Fit?]"]').val();
      var silhouetteData;
      if(pdpType_low == 'relaxed t-shirts' || pdpType_low == 't-shirts' || pdpType_low == "oversized t-shirts" || pdpType_low == "long sleeve polo t-shirts" || pdpType_low == 'bundi' || pdpType_low == 'knitpants' || pdpType_low == 'smartpants' ||  pdpType_low == 'jackets' || pdpType_low == 'suit blazer' ||  pdpType_low == 'long jackets' || pdpType_low == 'stretch denim' || pdpType_low == 'rigid denim' || pdpType_low == 'wide leg pants' || pdpType_low == 'casual chinos' || pdpType_low == 'mid rise stretch jeans' || pdpType_low == 'pleated chinos' || pdpType_low == 'lounge pants' || pdpType_low == 'mid rise lounge pants' || pdpType_low == 'fatigue pants' || pdpType_low == 'relaxed linen pants'){
        silhouetteData = 'NA';
      }else if(pdpType_low == 'linen pants'){
        silhouetteData = 'Straight';
      }else{
        silhouetteData = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Silhouette?]"]').val();
      }
    }
    console.log("setLocalStoreData function");
    setLocalStoreData(bodyType,hipClass,height,shirtSize,shoulderType,preferredFit,subSize,silhouetteData,pdpType_low,design_type);
    
  }else{ // logged in view
    async function asyncCall(){
      $('body').addClass('showAnimation');
      // $('.scan-success-loader img').show();
      toggleBodyScanGif(true);
    }
    if(pdpType_low == 'shirt'){
      var bodyType = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Body Type?]"]').val();
      var shirtSize = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Shirt Size?]"]').val();
      var shoulderType = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Shoulder Type?]"]').val();
      var height = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Height?]"]').val();
      var preferredFit = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Preferred Fit?]"]').val();
      var hipSemi = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Hip?]"]').val();      
      var bscArr = [];
      var bscData = {
        "gender": "Male",
        "category": "Shirts",
        "brand": "BOM",
        "fitSmart": {
          "bodyShape": bodyType,
          "stdSize": shirtSize,
          "height": height,
          "fit": preferredFit,
          "shoulderType": shoulderType,
          "hipClass": hipSemi
        }
      }
      bscArr.push(bscData);
      asyncCall();
      setTimeout(() => {
        console.log("calculate size createMeasurement");
        createMeasurement1(bscArr);
      }, 500);
    }else{ //  other category
      var bodyTypeSemi = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Body Type?]"]').val();
      var hipSemi = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Hip?]"]').val();
      var heightSemi = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Height?]"]').val();
      var shirtSizeSemi = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Size?]"]').val().toLowerCase();
      var silhouette = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Silhouette?]"]').val();
      var _Preferred_fit = $('[data-fitsmart-questions-main] input.activeradio[name="properties[_Preferred Fit?]"]').val();
      var pdpCat = pdpType_low;
      var silhouettePValue = silhouette;
      if(pdpType_low == 'jeans'){
        pdpCat = "Jeans";
        silhouettePValue = silhouette;
      }else if(pdpType_low == 'dress pants'){
        pdpCat = "DRESS_PANTS";
        silhouettePValue = silhouette;
      }else if(pdpType_low == 'neapolitan dress pants'){
        pdpCat = "NEAPOLITAN_DRESS_PANTS";
        silhouettePValue = silhouette;
      }else if(pdpType_low == 'relaxed neapolitan pants'){
        pdpCat = "RELAXED_NEAPOLITAN_PANTS";
        silhouettePValue = silhouette;
      }else if(pdpType_low == 'chinos'){
        pdpCat = "Chinos";
        silhouettePValue = silhouette;
      }else if(pdpType_low == 't-shirts'){
        pdpCat = "TShirts";
        silhouettePValue = "NA";
      }else if(pdpType_low == 'relaxed t-shirts'){
        pdpCat = "RELAXED_TSHIRTS";
        silhouettePValue = "NA";
      }else if(pdpType_low == 'oversized t-shirts'){
        pdpCat = "OVERSIZED_TSHIRTS";
        silhouettePValue = "NA";
      }else if(pdpType_low == 'long sleeve polo t-shirts'){
        pdpCat = "LONG_SLEEVE_POLO_TSHIRTS";
        silhouettePValue = "NA";
      }else if(pdpType_low == 'bundi'){
        pdpCat = "BUNDI";
      }else if(pdpType_low == 'jackets'){
        pdpCat = "Jackets";
      }else if(pdpType_low == 'suit blazer'){
        pdpCat = "SUIT_BLAZER";
      }else if(pdpType_low == 'long jackets'){
        pdpCat = "LONG_JACKETS";
      }else if(pdpType_low == 'knitpants'){
        pdpCat = "Knitpants";
        silhouettePValue = "NA";
      }else if(pdpType_low == 'smartpants'){
        pdpCat = "SMARTPANTS";
        silhouettePValue = "NA";
      }else if(pdpType_low == 'linen pants'){
        pdpCat = "LINEN_PANTS";
        silhouettePValue = "Straight";
      }else if(pdpType_low == 'relaxed linen pants'){
        pdpCat = "RELAXED_LINEN_PANTS";
        silhouettePValue = "NA";
      }else if(pdpType_low == 'wide leg pants'){
        pdpCat = "WIDE_LEG_PANTS";
        silhouettePValue = "Straight";
      }else if(pdpType_low == 'mid rise stretch jeans'){
        pdpCat = "MID_RISE_STRETCH_JEANS";
        silhouettePValue = "NA";
      }else if(pdpType_low == 'mid rise lounge pants'){
        pdpCat = "MID_RISE_LOUNGE_PANTS";
        silhouettePValue = "NA";
      }else if(pdpType_low == 'stretch denim' || pdpType_low == 'rigid denim' || pdpType_low == 'casual chinos' || pdpType_low == 'pleated chinos' || pdpType_low == 'lounge pants' || pdpType_low == 'fatigue pants'){
        pdpCat = pdpType_low.replace(" ","_").toUpperCase();
        silhouettePValue = "NA";
      }
      console.log('silhouettePValue',silhouettePValue);
      var semiArr = [];
      if(pdpType_low == 'jackets'){
        var semiData = {
          "gender": "Male",
          "category": pdpCat,
          "brand": "BOM",
          "fit": _Preferred_fit,
          "designType": designType,
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "fabricType": "NA"
        }
        console.log("semiData",semiData);
      }else if(pdpType_low == 'suit blazer'){
        var semiData = {
          "gender": "Male",
          "category": pdpCat,
          "brand": "BOM",
          "fit": _Preferred_fit,
          "designType": designType,
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "fabricType": "NA"
        }
        console.log("semiData",semiData);
      }else if(pdpType_low == 'long jackets'){
        if (pdpCat == "Long Jackets") {
          pdpCat = "LONG_JACKETS"
        }
        var semiData = {
          "gender": "Male",
          "category": pdpCat,
          "brand": "BOM",
          "fit": _Preferred_fit,
          "designType": designType,
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "fabricType": "NA"
        }
        console.log("semiData",semiData);
      }else if(pdpType_low == 'dress pants'){

        if (designType == "HEMMING") {
          silhouettePValue = "NA";
        } else if (designType == "SEMI_STITCHED") {
          silhouettePValue = silhouettePValue;
        }

        var semiData = {
          "gender": "Male",
          "category": "DRESS_PANTS",
          "brand": "BOM",
          "fit": _Preferred_fit,
          "designType": designType,
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "silhouette": silhouettePValue,
          "fabricType": "NA"
        }
        console.log("semiData",semiData);
      }else if(pdpType_low == 'bundi'){
        var semiData = {
          "gender": "Male",
          "category": "BUNDI",
          "brand": "BOM",
          "fit": "NA",
          "designType": "SEMI_STITCHED",
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "silhouette": silhouettePValue,
          "fabricType": "NA"
        };
      }else if(pdpType_low == 'relaxed neapolitan pants'){
        var semiData = {
          "gender": "Male",
          "category": "RELAXED_NEAPOLITAN_PANTS",
          "brand": "BOM",
          "fit": "NA",
          "designType": "SEMI_STITCHED",
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "silhouette": silhouettePValue,
          "fabricType": "NA"
        };
      }else if(pdpType_low == 'relaxed t-shirts'){
        var semiData = {
          "gender": "Male",
          "category": "RELAXED_TSHIRTS",
          "brand": "BOM",
          "fit": "NA",
          "designType": "HEMMING",
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "silhouette": silhouettePValue,
          "fabricType": "NA"
        };
      }else if(pdpType_low == 'oversized t-shirts'){
        var semiData = {
          "gender": "Male",
          "category": "OVERSIZED_TSHIRTS",
          "brand": "BOM",
          "fit": "NA",
          "designType": "HEMMING",
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "silhouette": silhouettePValue,
          "fabricType": "NA"
        };
      }else if(pdpType_low == 'long sleeve polo t-shirts'){
        var semiData = {
          "gender": "Male",
          "category": "LONG_SLEEVE_POLO_TSHIRTS",
          "brand": "BOM",
          "fit": "NA",
          "designType": "HEMMING",
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "silhouette": silhouettePValue,
          "fabricType": "NA"
        };
      }else if(pdpType_low == 'relaxed linen pants'){
        var semiData = {
          "gender": "Male",
          "category": "RELAXED_LINEN_PANTS",
          "brand": "BOM",
          "fit": "NA",
          "designType": "HEMMING",
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "silhouette": silhouettePValue,
          "fabricType": "NA"
        };
      }else if(pdpType_low == 'wide leg pants'){
        var semiData = {
          "gender": "Male",
          "category": "WIDE_LEG_PANTS",
          "brand": "BOM",
          "fit": "NA",
          "designType": "HEMMING",
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "silhouette": silhouettePValue,
          "fabricType": "NA"
        };
      }else if(pdpType_low == 'stretch denim' || pdpType_low == 'mid rise stretch jeans' || pdpType_low == 'relaxed t-shirts' || pdpType_low == 'oversized t-shirts' || pdpType_low == 'long sleeve polo t-shirts' || pdpType_low == 'rigid denim' || pdpType_low == 'casual chinos' || pdpType_low == 'pleated chinos' || pdpType_low == 'lounge pants' || pdpType_low == 'mid rise lounge pants' || pdpType_low == 'fatigue pants'){
        var semiData = {
          "gender": "Male",
          "category": pdpCat,
          "brand": "BOM",
          "fit": "NA",
          "designType": "HEMMING",
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "silhouette": silhouettePValue,
          "fabricType": "NA"
        };
      }else{
        var semiData = {
          "gender": "Male",
          "category": pdpCat,
          "brand": "BOM",
          "fit": "NA",
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi,
              "hipClass": hipSemi
          },
          "silhouette": silhouettePValue,
          "fabricType": "NA"
        }
      }
      semiArr.push(semiData);
      asyncCall();
      setTimeout(() => {
        console.log("calculate size createMeasurement");
        createMeasurement1(semiArr);
      }, 500);
    }
  }
});

// [data-save-changes-btn] -- SAVE CHANGES
$(document).on("click","[data-save-changes-btn]",function(e){
  e.preventDefault();
  console.log("save-changes-btn btn clicked");
  if($(this).attr("data-type") == "edit-profiles"){
    $("[data-edit-confirm-profile-ele]").removeClass("hide");
    $("[data-edit-confirm-size-ele]").addClass("hide");
  }else{
    $("[data-edit-confirm-profile-ele]").addClass("hide");
    $("[data-edit-confirm-size-ele]").removeClass("hide");
  }
  document.body.classList.add("fitsmart-edit-confirm");
  if(document.body.classList.contains("notlogged")){
    // Start - Get localstorage data
    fitsmartObject = localStorage.getItem("fitsmartobjNew");
    fitsmartObject = JSON.parse(fitsmartObject);
    var editLineBSC;
    if(pdpType_low == 'jackets' || pdpType_low == 'suit blazer' || pdpType_low == 'long jackets' || pdpType_low == 'shirt'){
      var editLineBSC = jQuery.grep(fitsmartObject, function(n,i){
        return (n.category == pdpType_low && n.designType == designType);
      });
    }else{
      var editLineBSC = jQuery.grep(fitsmartObject, function(n,i){
        return (n.category == pdpType_low);
      });
    }
    console.log('save changes editLineBSC',editLineBSC);
    var profileFitsmart = jQuery.grep(fitsmartObject, function(n,i){
      return (n.designType != "READY_TO_WEAR" && n.type != "STANDARD");
    });
    if(profileFitsmart.length){
      var st_bType = profileFitsmart[0]['_Body Type?'];
      var st_height = profileFitsmart[0]['_Height?'];
      var st_hip = profileFitsmart[0]['_Hip?'];
    }    
    // Start - Replace HTML of profile data
    var newBodyTypeData = $('[data-edit-profile-ele] [name="properties[_Body Type?]"].activeradio').val();
    var newHeigthData = $('[data-edit-profile-ele] [name="properties[_Height?]"].activeradio').val();
    var newHipData = $('[data-edit-profile-ele] [name="properties[_Hip?]"].activeradio').val();
    if(st_bType != newBodyTypeData){
      $('[data-edit-confirm-profile-ele] .ProductSize__BodyType').removeClass('hide');
      let newBodyTypeHtml = $('[data-edit-profile-ele] [name="properties[_Body Type?]"].activeradio').siblings('label').html();
      $('.new_bodyType label').html(newBodyTypeHtml);
      let oldBodyTypeHtml = $('[data-edit-profile-ele] [name="properties[_Body Type?]"][value="'+st_bType+'"]').siblings('label').html();
      $('.old_bodyType label').html(oldBodyTypeHtml);
    }else{
      $('[data-edit-confirm-profile-ele] .ProductSize__BodyType').addClass('hide');
    }
    if(st_height != newHeigthData){
      $('[data-edit-confirm-profile-ele] .ProductSize__Height').removeClass('hide');
      let newHeightHtml = $('[data-edit-profile-ele] [name="properties[_Height?]"].activeradio').siblings('label').html();
      $('.new_height label').html(newHeightHtml);
      let oldHeightHtml = $('[data-edit-profile-ele] [name="properties[_Height?]"][value="'+st_height+'"]').siblings('label').html();
      $('.old_height label').html(oldHeightHtml);
    }else{
      $('[data-edit-confirm-profile-ele] .ProductSize__Height').addClass('hide');
    }
    if(st_hip != newHipData){
      $('[data-edit-confirm-profile-ele] .ProductSize__Hip').removeClass('hide');
      let newHipHtml = $('[data-edit-profile-ele] [name="properties[_Hip?]"].activeradio').siblings('label').html();
      $('.new_hip label').html(newHipHtml);
      let oldHipHtml = $('[data-edit-profile-ele] [name="properties[_Hip?]"][value="'+st_hip+'"]').siblings('label').html();
      $('.old_hip label').html(oldHipHtml);
    }else{
      $('[data-edit-confirm-profile-ele] .ProductSize__Hip').addClass('hide');
    }
    // End - Replace HTML of profile data
    
    // Start - Replace HTML of size data
    if(editLineBSC.length > 0){
      if(editLineBSC[0]['_Shirt Size?'] != undefined){
        var st_size = editLineBSC[0]['_Shirt Size?'];
        let newShirtSizeVal = $('[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio').val();
        if(st_size != newShirtSizeVal){
          $('[data-edit-confirm-size-ele] .ProductSize__ShirtSize').removeClass('hide');
          let newShirtSizeHtml = $('[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio').siblings('label').html();
          $('.new_shirtSize label').html(newShirtSizeHtml);
          let ls_ShirtSizeHtml = $('[data-edit-size-ele] [name="properties[_Shirt Size?]"][value="'+st_size+'"]').siblings('label').html();
          $('.old_shirtSize label').html(ls_ShirtSizeHtml);
        }else{
          $('[data-edit-confirm-size-ele] .ProductSize__ShirtSize').addClass('hide');
        }
      }
      if(editLineBSC[0]['_Shoulder Type?'] != undefined){
        var st_shType = editLineBSC[0]['_Shoulder Type?'];
        let newSholderTypeVal = $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio').val();
        if(st_shType != newSholderTypeVal){
          $('[data-edit-confirm-size-ele] .ProductSize__ShoulderType').removeClass('hide');
          let newSholderTypeHtml = $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio').siblings('label').html();
          $('.new_shoulderType label').html(newSholderTypeHtml);
          let ls_SholderTypeHtml = $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"][value="'+st_shType+'"]').siblings('label').html();
          $('.old_shoulderType label').html(ls_SholderTypeHtml);
        }else{
          $('[data-edit-confirm-size-ele] .ProductSize__ShoulderType').addClass('hide');
        }
      }
      if(editLineBSC[0]['_Preferred Fit?'] != undefined){
        var st_fit = editLineBSC[0]['_Preferred Fit?'];
        let newPreferredFitVal = $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio').val();
        if(st_fit != newPreferredFitVal){
          $('[data-edit-confirm-size-ele] .ProductSize__PreferredFit').removeClass('hide');
          let newPreferredFitHtml = $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio').siblings('label').html();
          $('.new_preferredFit label').html(newPreferredFitHtml);
          let ls_PreferredFitHtml = $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"][value="'+st_fit+'"]').siblings('label').html();
          $('.old_preferredFit label').html(ls_PreferredFitHtml);
        }else{
          $('[data-edit-confirm-size-ele] .ProductSize__PreferredFit').addClass('hide');
        }
      }
      if(editLineBSC[0]['_Size?'] != undefined){
        let st_semiSize = editLineBSC[0]['_Size?'];
        let newSizeVal = $('.edit_data_module .edit_size_module [name="properties[_Size?]"].activeradio').val();
        if(st_semiSize != newSizeVal){
          $('[data-edit-confirm-size-ele] .ProductSize__ShirtSize').removeClass('hide');
          let newSemiSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Size?]"].activeradio').siblings('label').html();
          $('.new_shirtSize label').html(newSemiSizeHtml);
          let ls_SemiSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Size?]"][value="'+st_semiSize+'"]').siblings('label').html();
          $('.old_shirtSize label').html(ls_SemiSizeHtml);
        }else{
          $('[data-edit-confirm-size-ele] .ProductSize__ShirtSize').addClass('hide');
        }
      }
      if(editLineBSC[0]['_Silhouette?'] != undefined){
        let st_semiSil = editLineBSC[0]['_Silhouette?'];
        let newSilVal = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"].activeradio').val();
        if(st_semiSil != newSilVal){
          $('[data-edit-confirm-size-ele] .ProductSize__Silhouette').removeClass('hide');
          let newSemiSilHtml = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"].activeradio').siblings('label').html();
          $('.new_silhouette label').html(newSemiSilHtml);
          let ls_SemiSilHtml = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"][value="'+st_semiSil+'"]').siblings('label').html();
          $('.old_silhouette label').html(ls_SemiSilHtml);
        }else{
          $('[data-edit-confirm-size-ele] .ProductSize__Silhouette').addClass('hide');
        }
      }
    }
    // End - Replace HTML of size data
  }else{
    // logged in
    // Start - Get fitsmart data
    var fitsmartProfileAPI_obj = localStorage.getItem("getprofile");
    fitsmartProfiles = JSON.parse(fitsmartProfileAPI_obj)?.fitProfiles;
    var profileFitsmart = JSON.parse(fitsmartProfileAPI_obj)?.profileFitsmart;
    console.log('fitsmartProfiles',fitsmartProfiles);
    var editLineBSC;
    if(pdpType_low == 'jackets' || pdpType_low == 'suit blazer' || pdpType_low == 'long jackets' || pdpType_low == 'shirt'){
      var editLineBSC = jQuery.grep(fitsmartProfiles, function(n,i){
        return (n.categoryName == pdpType_low && n.designType == designType);
      });
    }else{
      var editLineBSC = jQuery.grep(fitsmartProfiles, function(n,i){
        return (n.categoryName == pdpType_low);
      });
    }
    console.log('save changes editLineBSC',editLineBSC);
    // var profileFitsmart = jQuery.grep(fitsmartProfiles, function(n,i){
    //   return (n.designType != "READY_TO_WEAR" && n.type != "STANDARD");
    // });
    // if(editLineBSC.length){
      var st_bType = profileFitsmart.bodyShape;
      var st_height = profileFitsmart.height;
      var st_hip = profileFitsmart.hipClass;
    // }
    // Start - Replace HTML of profile data
    var newBodyTypeData = $('[data-edit-profile-ele] [name="properties[_Body Type?]"].activeradio').val();
    var newHeigthData = $('[data-edit-profile-ele] [name="properties[_Height?]"].activeradio').val();
    var newHipData = $('[data-edit-profile-ele] [name="properties[_Hip?]"].activeradio').val();    
    if(st_bType != newBodyTypeData){
      $('[data-edit-confirm-profile-ele] .ProductSize__BodyType').removeClass('hide');
      let newBodyTypeHtml = $('[data-edit-profile-ele] [name="properties[_Body Type?]"].activeradio').siblings('label').html();
      $('.new_bodyType label').html(newBodyTypeHtml);
      let oldBodyTypeHtml = $('[data-edit-profile-ele] [name="properties[_Body Type?]"][value="'+st_bType+'"]').siblings('label').html();
      $('.old_bodyType label').html(oldBodyTypeHtml);
    }else{
      $('[data-edit-confirm-profile-ele] .ProductSize__BodyType').addClass('hide');
    }
    if(st_height != newHeigthData){
      $('[data-edit-confirm-profile-ele] .ProductSize__Height').removeClass('hide');
      let newHeightHtml = $('[data-edit-profile-ele] [name="properties[_Height?]"].activeradio').siblings('label').html();
      $('.new_height label').html(newHeightHtml);
      let oldHeightHtml = $('[data-edit-profile-ele] [name="properties[_Height?]"][value="'+st_height+'"]').siblings('label').html();
      $('.old_height label').html(oldHeightHtml);
    }else{
      $('[data-edit-confirm-profile-ele] .ProductSize__Height').addClass('hide');
    }
    if(st_hip != newHipData){
      $('[data-edit-confirm-profile-ele] .ProductSize__Hip').removeClass('hide');
      let newHipHtml = $('[data-edit-profile-ele] [name="properties[_Hip?]"].activeradio').siblings('label').html();
      $('.new_hip label').html(newHipHtml);
      let oldHipHtml = $('[data-edit-profile-ele] [name="properties[_Hip?]"][value="'+st_hip+'"]').siblings('label').html();
      $('.old_hip label').html(oldHipHtml);
    }else{
      $('[data-edit-confirm-profile-ele] .ProductSize__Hip').addClass('hide');
    }
    // End - Replace HTML of profile data
    
    // Start - Replace HTML of size data
    if(editLineBSC.length > 0){
      // if(editLineBSC[0].categoryName == "shirt"){
        if(editLineBSC[0].fitsmart.stdSize != undefined){
          var st_size = editLineBSC[0].fitsmart.stdSize.value;
          if(editLineBSC[0].categoryName == "relaxed t-shirts" || editLineBSC[0].categoryName == "t-shirts" || editLineBSC[0].categoryName == "oversized t-shirts" || editLineBSC[0].categoryName == "long sleeve polo t-shirts"){
            st_size = editLineBSC[0].fitsmart.stdSize.value.toUpperCase();
          }
          if(templateType == 'template-bsc'){
            let newShirtSizeVal = $('[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio').val();
            if(st_size != newShirtSizeVal){
              $('[data-edit-confirm-size-ele] .ProductSize__ShirtSize').removeClass('hide');
              let newShirtSizeHtml = $('[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio').siblings('label').html();
              $('.new_shirtSize label').html(newShirtSizeHtml);
              let ls_ShirtSizeHtml = $('[data-edit-size-ele] [name="properties[_Shirt Size?]"][value="'+st_size+'"]').siblings('label').html();
              $('.old_shirtSize label').html(ls_ShirtSizeHtml);
            }else{
              $('[data-edit-confirm-size-ele] .ProductSize__ShirtSize').addClass('hide');
            }
          }else if(templateType == 'template-semi-stitched'){
            let newShirtSizeVal = $('[data-edit-size-ele] [name="properties[_Size?]"].activeradio').val();
            if(st_size != newShirtSizeVal){
              $('[data-edit-confirm-size-ele] .ProductSize__ShirtSize').removeClass('hide');
              let newShirtSizeHtml = $('[data-edit-size-ele] [name="properties[_Size?]"].activeradio').siblings('label').html();
              $('.new_shirtSize label').html(newShirtSizeHtml);
              let ls_ShirtSizeHtml = $('[data-edit-size-ele] [name="properties[_Size?]"][value="'+st_size+'"]').siblings('label').html();
              $('.old_shirtSize label').html(ls_ShirtSizeHtml);
            }else{
              $('[data-edit-confirm-size-ele] .ProductSize__ShirtSize').addClass('hide');
            }
          }
        }
      // }
      if(editLineBSC[0].fitsmart.shoulderType != undefined){
        var st_shType = editLineBSC[0].fitsmart.shoulderType.value;
        let newSholderTypeVal = $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio').val();
        if(st_shType != newSholderTypeVal){
          $('[data-edit-confirm-size-ele] .ProductSize__ShoulderType').removeClass('hide');
          let newSholderTypeHtml = $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio').siblings('label').html();
          $('.new_shoulderType label').html(newSholderTypeHtml);
          let ls_SholderTypeHtml = $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"][value="'+st_shType+'"]').siblings('label').html();
          $('.old_shoulderType label').html(ls_SholderTypeHtml);
        }else{
          $('[data-edit-confirm-size-ele] .ProductSize__ShoulderType').addClass('hide');
        }
      }
      if(editLineBSC[0].fitsmart.fit != undefined){
        var st_fit = editLineBSC[0].fitsmart.fit.value;
        let newPreferredFitVal = $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio').val();
        if(st_fit != newPreferredFitVal){
          $('[data-edit-confirm-size-ele] .ProductSize__PreferredFit').removeClass('hide');
          let newPreferredFitHtml = $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio').siblings('label').html();
          $('.new_preferredFit label').html(newPreferredFitHtml);
          let ls_PreferredFitHtml = $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"][value="'+st_fit+'"]').siblings('label').html();
          $('.old_preferredFit label').html(ls_PreferredFitHtml);
        }else{
          $('[data-edit-confirm-size-ele] .ProductSize__PreferredFit').addClass('hide');
        }
      }
      // if(editLineBSC[0]['_Size?'] != undefined){
      //   let st_semiSize = editLineBSC[0]['_Size?'];
      //   let newSizeVal = $('.edit_data_module .edit_size_module [name="properties[_Size?]"].activeradio').val();
      //   if(st_semiSize != newSizeVal){
      //     $('[data-edit-confirm-size-ele] .ProductSize__ShirtSize').removeClass('hide');
      //     let newSemiSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Size?]"].activeradio').siblings('label').html();
      //     $('.new_size label').html(newSemiSizeHtml);
      //     let ls_SemiSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Size?]"][value="'+st_semiSize+'"]').siblings('label').html();
      //     $('.old_size label').html(ls_SemiSizeHtml);
      //   }else{
      //     $('[data-edit-confirm-size-ele] .ProductSize__ShirtSize').addClass('hide');
      //   }
      // }
      if(editLineBSC[0].fitsmart.silhouette != undefined){
        let st_semiSil = editLineBSC[0].fitsmart.silhouette.value;
        let newSilVal = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"].activeradio').val();
        if(st_semiSil != newSilVal){
          $('[data-edit-confirm-size-ele] .ProductSize__Silhouette').removeClass('hide');
          let newSemiSilHtml = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"].activeradio').siblings('label').html();
          $('.new_silhouette label').html(newSemiSilHtml);
          let ls_SemiSilHtml = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"][value="'+st_semiSil+'"]').siblings('label').html();
          $('.old_silhouette label').html(ls_SemiSilHtml);
        }else{
          $('[data-edit-confirm-size-ele] .ProductSize__Silhouette').addClass('hide');
        }
      }
    }
    // End - Replace HTML of size data
  }  
});

// data-edit-confirm-fitsmart-close EDIT CONFIRM POPUP CLOSE
$(document).on("click","[data-edit-confirm-fitsmart-close], body.fitsmart-edit-confirm .product-fitsmart-overlay",function(e){
  e.preventDefault();
  console.log("edit confirm popup close btn clicked");
  document.body.classList.remove("fitsmart-edit-confirm");
});

// data-confirm-changes-btn CONFIRM CHANGES
$(document).on("click","[data-confirm-changes-btn]",function(e){
  e.preventDefault();
  $('[data-save-changes-btn]').addClass('disabled');
  // Start-animation start
  setTimeout(function(){
  $('body').addClass('showAnimation');
  // $('.scan-success-loader img').show();
  toggleBodyScanGif(true);
  },200);
  // End- animation start
  console.log("edit confirm popup close btn clicked");
  setTimeout( () => {
    document.body.classList.remove("fitsmart-edit-confirm");
    document.body.classList.remove("fitsmart-edit");
  },300);
  var newBodyTypeData = $('[data-edit-profile-ele] [name="properties[_Body Type?]"].activeradio').val();
  var newHeigthData = $('[data-edit-profile-ele] [name="properties[_Height?]"].activeradio').val();
  var newHipData = $('[data-edit-profile-ele] [name="properties[_Hip?]"].activeradio').val();
  // sizes data
  var shirtSize = $('[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio').val() : "NA";
  var shoulderType = $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio').val() : "NA";
  var preferredFit = $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio').val() : "NA";
  var size = $('[data-edit-size-ele] [name="properties[_Size?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Size?]"].activeradio').val() : "NA";
  var silhouette = $('[data-edit-size-ele] [name="properties[_Silhouette?]"].activeradio').length ? $('[data-edit-size-ele] [name="properties[_Silhouette?]"].activeradio').val() : "NA";
  if(pdpType_low == 'linen pants' ){
    silhouette = 'Straight';
  } else if (pdpType_low == 'mid rise stretch jeans') {
    silhouette = 'NA';
  }
  if(document.body.classList.contains("notlogged")){
    // pass all value for to set LOCAL fitsmart
    setLocalStoreData(newBodyTypeData,newHipData,newHeigthData,shirtSize,shoulderType,preferredFit,size,silhouette,pdpType_low,designType);
  }else{
    // logged in
    if(this.dataset.type == "confirm-profiles"){
      var profileArr = [];
      var profileData = {
        "gender": "Male",
        "brand": "NA",
        "category": "NA",
        "fitSmart": {
          "bodyShape": newBodyTypeData,
          "height": newHeigthData,
          "hipClass": newHipData
        }
      }
      console.log('profileData',profileData);      
      profileArr.push(profileData);
      $('body').addClass('showAnimation');
      // $('.scan-success-loader img').show();
      toggleBodyScanGif(true);
      setTimeout(() => {
        console.log("confirm change btn createMeasurement");
        createMeasurement1(profileArr);
      }, 500);
    }else{
      // sizes changes
      if(pdpType_low == 'shirt'){
        var bscArr = [];
        var bscData = {
          "gender": "Male",
          "category": "Shirts",
          "brand": "BOM",
          "fitSmart": {
            "stdSize": shirtSize,
            "fit": preferredFit,
            "shoulderType": shoulderType
          }
        }
        bscArr.push(bscData);
        $('body').addClass('showAnimation');
        // $('.scan-success-loader img').show();
        toggleBodyScanGif(true);
        setTimeout(() => {
          console.log("confirm change btn createMeasurement");
          createMeasurement1(bscArr);
        }, 500);
      }else{
        if(pdpType_low == 'linen pants'){
          silhouette = 'Straight';
        } else if (pdpType_low == 'mid rise stretch jeans') {
          silhouette = 'NA';
        }
        let pdpCat = getCreateMeasurementCategory(pdpType_low);
        var semiArr = [];
          if(pdpType_low == 'relaxed neapolitan pants'){
            pdpCat = "RELAXED_NEAPOLITAN_PANTS"
          }
        if(pdpType_low == 'jackets' || pdpType_low == 'suit blazer' || pdpType_low == 'long jackets' || pdpType_low == 'bundi'){
          if (pdpCat == "Long Jackets" ) {
            pdpCat = "LONG_JACKETS"
          }
          var semiData = {
            "gender": "Male",
            "category": pdpCat,
            "designType": designType,
            "brand": "BOM",
            "fit": preferredFit,
            "fitSmart": {
              "stdSize": size.toLowerCase(),
            }
          }
        }else if(pdpType_low == 'stretch denim' || pdpType_low == 'dress pants' || pdpType_low == 'relaxed neapolitan pants' || pdpType_low == 'mid rise stretch jeans' || pdpType_low == 'relaxed t-shirts' || pdpType_low == 'oversized t-shirts' || pdpType_low == 'long sleeve polo t-shirts' || pdpType_low == 'rigid denim' || pdpType_low == 'casual chinos' || pdpType_low == 'pleated chinos' || pdpType_low == 'lounge pants' || pdpType_low == 'mid rise lounge pants' || pdpType_low == 'fatigue pants' || pdpType_low == 'relaxed linen pants' || pdpType_low == 'wide leg pants' || pdpType_low == 'chinos'){
          var semiData = {
            "gender": "Male",
            "category": pdpCat,
            "designType": designType,
            "brand": "BOM",
            "fit": "NA",
            "fitSmart": {
              "stdSize": size.toLowerCase(),
            },
            "silhouette": silhouette,
          };
        }else{
          var semiData = {
            "gender": "Male",
            "category": pdpCat,
            "brand": "BOM",
            "fit": "NA",
            "fitSmart": {
            "stdSize": size.toLowerCase(),
            },
            "silhouette": silhouette,
          }
        }
        semiArr.push(semiData);
        $('body').addClass('showAnimation');
        // $('.scan-success-loader img').show();
        toggleBodyScanGif(true);
        setTimeout(() => {
          console.log("confirm change btn createMeasurement");
          createMeasurement1(semiArr);
        }, 500);
      }
    }
  }
});

function checkForStandardSizeLocal(){
  thefitsmartObject = localStorage.getItem("fitsmartobjNew");
  var fitsmartObjMain = JSON.parse(thefitsmartObject);
  var cateFitsmartObj = jQuery.grep(fitsmartObjMain, function(n,i){
    return (n.category == pdpType_low && n.designType == designType && n.fitSmartType == "STANDARD");
  });
  console.log("standard size cateFitsmartObj",cateFitsmartObj);
  $("[data-pro-need-more-range]").removeClass("hide");
  $("[data-pro-saved-sizing]").addClass("hide");
  $("[data-pro-standard-size-main]").removeClass("hide");
  if(cateFitsmartObj.length > 0){
    // fitsmart type == STANDARD
    if (cateFitsmartObj[0]["getsize"] && !document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"]:checked`)){
      setTimeout(function(){
        if(cateFitsmartObj[0].category == "relaxed t-shirts" || cateFitsmartObj[0].category == "t-shirts" || cateFitsmartObj[0].category == "oversized t-shirts" || cateFitsmartObj[0].category == "long sleeve polo t-shirts"){
          if(document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmartObj[0]["getsize"].toLowerCase()}"]`)) document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmartObj[0]["getsize"].toLowerCase()}"]`).click();
        }else{
          if(document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmartObj[0]["getsize"]}"]`)) document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmartObj[0]["getsize"]}"]`).click();
        }
        let sizeselect = cateFitsmartObj[0]["getsize"];
        if(pdpType_low == 'shirt'){
          let sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
          sizeselect = sizeTable[sizeselect];
        }
        console.log("1872");
        $('[data-standard-rec-size]').html(`${sizeselect}`).parents(".standard-rec-size-content").removeClass("hide");
      },500);
    }
  }
}

function checkForStandardSizeLoginView(){
  console.log("checkForStandardSizeLoginView>>>>>>>")
  var fitsmartProfileAPI_obj = localStorage.getItem("getprofile");
  fitsmartProfiles = JSON.parse(fitsmartProfileAPI_obj)?.fitProfiles;
  console.log('fitsmartProfiles',fitsmartProfiles);
  if(fitsmartProfiles.length > 0){
    if(pdpType_low == 'jackets' || pdpType_low == 'suit blazer' || pdpType_low == 'long jackets' || pdpType_low == 'shirt' || pdpType_low == 'bundi'){
      var cateFitsmartObj = jQuery.grep(fitsmartProfiles, function(n,i){
        return (n.categoryName == pdpType_low && n.designType == designType && n.fitProfileId != null);
      });
    }else{
      const compareDesignType = designType === "SEMI_STITCHED" ? "CUSTOM_DESIGN" : designType;
      var cateFitsmartObj = jQuery.grep(fitsmartProfiles, function(n,i){
        return (n.categoryName == pdpType_low && n.designType == compareDesignType && n.fitProfileId != null);
      });
    }

    const profileType = cateFitsmartObj?.[0]?.type;

    console.log("standard size cateFitsmartObj",cateFitsmartObj);
    if(cateFitsmartObj.length > 0 && profileType == "STANDARD"){
      // fitsmart type == STANDARD
      $("[data-pro-need-more-range]").removeClass("hide");
      $("[data-pro-saved-sizing]").addClass("hide");
      $("[data-pro-standard-size-main]").removeClass("hide");
      if (cateFitsmartObj[0].fitsmart.stdSize && !document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"]:checked`)){
        setTimeout(function(){
          document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmartObj[0].fitsmart.stdSize.value}"]`).click();
        },500);
        let sizeselect = cateFitsmartObj[0].fitsmart.stdSize.value;
        if(pdpType_low == 'shirt'){
          let sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
          sizeselect = sizeTable[sizeselect];
        }
        console.log("1909");
        $('[data-standard-rec-size]').html(`${sizeselect}`).parents(".standard-rec-size-content").removeClass("hide");
        if(cateFitsmartObj[0].fitsmart.stdSize.value){
          if(document.querySelector(`[data-pro-standard-size-main] input[type="radio"][value="${cateFitsmartObj[0].fitsmart.stdSize.value}"]`)) document.querySelector(`[data-pro-standard-size-main] input[type="radio"][value="${cateFitsmartObj[0].fitsmart.stdSize.value}"]`).click();
          $(`[data-pro-fitsmart-type-input]`).val("STANDARD");
          // var event = new Event('change', { bubbles: true });
          // document.querySelector(`[data-pro-standard-size-main] input[type="radio"][value="${cateFitsmartObj[0].fitsmart.stdSize.value}"]`).dispatchEvent(event);
        }
      }
    }
    if(cateFitsmartObj.length == 0){
      $("[data-pro-need-more-range]").removeClass("hide");
      $("[data-pro-standard-size-main]").removeClass("hide");
    }
  }else{
    $("[data-pro-need-more-range]").removeClass("hide");
    $("[data-pro-standard-size-main]").removeClass("hide");
  }
}

function checkForRTWLocal(){
  console.log("checkForRTWLocal>>>>>>>");
  thefitsmartObject = localStorage.getItem("fitsmartobjNew");
  var fitsmartObjMain = JSON.parse(thefitsmartObject);
  var cateFitsmartObj = jQuery.grep(fitsmartObjMain, function(n,i){
    return (n.category == pdpType_low && n.designType == "READY_TO_WEAR");
  });
  console.log("RTW size cateFitsmartObj",cateFitsmartObj);
  if(cateFitsmartObj.length > 0){
    // fitsmart type == READY_TO_WEAR
    if(cateFitsmartObj[0]["_Shirt Size?"] && document.querySelector(`.SizeSwatchList input[type="radio"][value="${cateFitsmartObj[0]["_Shirt Size?"]}"]`)){
      if(window.location.href.includes("itemid") == false || window.location.href.includes("customisable") == false){
        console.log("click need to click",cateFitsmartObj[0]["_Shirt Size?"]);
        document.querySelector(`.SizeSwatchList input[type="radio"][value="${cateFitsmartObj[0]["_Shirt Size?"]}"]`).click();
      }
    }
    if(cateFitsmartObj[0]["_Shirt Size?"]) {
      // $('.rtw-rec-size').html('size <span>'+ cateFitsmartObj[0]["_Shirt Size?"] +'</span> Recommended');
      $('.rtw-rec-size').html('Your last Selected Size : <span>'+ cateFitsmartObj[0]["_Shirt Size?"] +'</span>');
      
      $(".rtw-size-header").removeClass("hide");
    }
  }
}

function checkForRTWLoginView(){
  console.log("checkForRTWLoginView>>>>>>>")
  var fitsmartProfileAPI_obj = localStorage.getItem("getprofile");
  fitsmartProfiles = JSON.parse(fitsmartProfileAPI_obj)?.fitProfiles;
  console.log('fitsmartProfiles',fitsmartProfiles);
  if(fitsmartProfiles != undefined){
    var cateFitsmartObj = jQuery.grep(fitsmartProfiles, function(n,i){
      return (n.categoryName == pdpType_low && n.designType == "READY_TO_WEAR" && n.fitProfileId != null);
    });
    console.log("RTW size cateFitsmartObj",cateFitsmartObj);
    if(cateFitsmartObj.length > 0){
      // fitsmart type == READY_TO_WEAR
      if(cateFitsmartObj[0].fitsmart.stdSize && document.querySelector(`.SizeSwatchList input[type="radio"][value="${cateFitsmartObj[0].fitsmart.stdSize.value}"]`)){
        if(window.location.href.includes("itemid") == false || window.location.href.includes("customisable") == false){
          console.log("click need to click",cateFitsmartObj[0].fitsmart.stdSize.value);
          // document.querySelector(`.SizeSwatchList input[type="radio"][value="${cateFitsmartObj[0].fitsmart.stdSize.value}"]`).click();
          if(pdpType_low == 'sweatshirts' || pdpType_low == 'sweaters' || pdpType_low == 'joggers' || pdpType_low.includes("shorts")){
            document.querySelector(`.SizeSwatchList input[type="radio"][value="${cateFitsmartObj[0].fitsmart.stdSize.value.toUpperCase()}"]`).click();
          }else{
            document.querySelector(`.SizeSwatchList input[type="radio"][value="${cateFitsmartObj[0].fitsmart.stdSize.value}"]`).click();
          }
        }
      }
      if(cateFitsmartObj[0].fitsmart.stdSize){
        // $('.rtw-rec-size').html('size <span>'+ cateFitsmartObj[0].fitsmart.stdSize.value +'</span> Recommended');
        $('.rtw-rec-size').html('Your last Selected Size : <span>'+ cateFitsmartObj[0].fitsmart.stdSize.value +'</span>');
        
        $(".rtw-size-header").removeClass("hide");
      }
    }
  }
}

function resetFitsmartQuestions(haveProfileData = false){
  console.log("resetFitsmartQuestions>>>>>>> haveProfileData",haveProfileData);
  $("[data-product-fitsmart-global] .data_drawer_one").removeClass("hide");
  $("[data-product-fitsmart-global] .data_drawer_two").addClass("hide");
  if(haveProfileData == false){
    // $("[data-product-fitsmart-global] .data_drawer_one").removeClass("hide");
    // $("[data-product-fitsmart-global] .data_drawer_two").addClass("hide");
    $(".Im-New-Filter .ProductSize__BodyType").show();
    $(".Im-New-Filter .ProductSize__Hip").show();
    $(".Im-New-Filter .ProductSize__Height").show();
    $(".size-pop-profile").addClass("hide");
    if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Body Type?]"]:checked`) || document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Body Type?]"].activeradio`)){
      document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Body Type?]"].activeradio`)?.classList.remove("activeradio");
      if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Body Type?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Body Type?]"]:checked`).checked = false;
    }
    if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Hip?]"]:checked`) || document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Hip?]"].activeradio`)){
      document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Hip?]"].activeradio`)?.classList.remove("activeradio");
      if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Hip?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Hip?]"]:checked`).checked = false;
    }
    if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Height?]"]:checked`) || document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Height?]"].activeradio`)){
      document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Height?]"].activeradio`)?.classList.remove("activeradio");
      if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Height?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Height?]"]:checked`).checked = false;
    }
    
    if(document.querySelector(`[data-edit-profile-ele] [name="properties[_Body Type?]"]:checked`) || document.querySelector(`[data-edit-profile-ele] [name="properties[_Body Type?]"].activeradio`)){
      // document.querySelector(`[data-edit-profile-ele] [name="properties[_Body Type?]"].activeradio`)?.classList.remove("activeradio");
      $(`[data-edit-profile-ele] [name="properties[_Body Type?]"].activeradio`).removeClass("activeradio");
      if(document.querySelector(`[data-edit-profile-ele] [name="properties[_Body Type?]"]:checked`)) document.querySelector(`[data-edit-profile-ele] [name="properties[_Body Type?]"]:checked`).checked = false;
    }
    if(document.querySelector(`[data-edit-profile-ele] [name="properties[_Hip?]"]:checked`) || document.querySelector(`[data-edit-profile-ele] [name="properties[_Hip?]"].activeradio`)){
      // document.querySelector(`[data-edit-profile-ele] [name="properties[_Hip?]"].activeradio`)?.classList.remove("activeradio");
      $(`[data-edit-profile-ele] [name="properties[_Hip?]"].activeradio`).removeClass("activeradio");
      if(document.querySelector(`[data-edit-profile-ele] [name="properties[_Hip?]"]:checked`)) document.querySelector(`[data-edit-profile-ele] [name="properties[_Hip?]"]:checked`).checked = false;
    }
    if(document.querySelector(`[data-edit-profile-ele] [name="properties[_Height?]"]:checked`) || document.querySelector(`[data-edit-profile-ele] [name="properties[_Height?]"].activeradio`)){
      // document.querySelector(`[data-edit-profile-ele] [name="properties[_Height?]"].activeradio`)?.classList.remove("activeradio");
      $(`[data-edit-profile-ele] [name="properties[_Height?]"].activeradio`).removeClass("activeradio");
      if(document.querySelector(`[data-edit-profile-ele] [name="properties[_Height?]"]:checked`)) document.querySelector(`[data-edit-profile-ele] [name="properties[_Height?]"]:checked`).checked = false;
    }

    if(document.querySelector(`[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio`)){
      document.querySelector(`[data-edit-size-ele] [name="properties[_Shirt Size?]"].activeradio`)?.classList.remove("activeradio");
    }
    if(document.querySelector(`[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio`)){
      document.querySelector(`[data-edit-size-ele] [name="properties[_Shoulder Type?]"].activeradio`)?.classList.remove("activeradio");
    }
    if(document.querySelector(`[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio`)){
      document.querySelector(`[data-edit-size-ele] [name="properties[_Preferred Fit?]"].activeradio`)?.classList.remove("activeradio");
    }  
    if(document.querySelector(`[data-edit-size-ele] [name="properties[_Size?]"].activeradio`)){
      document.querySelector(`[data-edit-size-ele] [name="properties[_Size?]"].activeradio`)?.classList.remove("activeradio");
    }
    if(document.querySelector(`[data-edit-size-ele] [name="properties[_Silhouette?]"].activeradio`)){
      document.querySelector(`[data-edit-size-ele] [name="properties[_Silhouette?]"].activeradio`)?.classList.remove("activeradio");
    }
    
  }else{
    // $("[data-product-fitsmart-global] .data_drawer_one").addClass("hide");
    // $("[data-product-fitsmart-global] .data_drawer_two").removeClass("hide");
  }
  if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"]:checked`) || document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"].activeradio`)){
    document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"]:checked`)?.classList.remove("activeradio");
    document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"].activeradio`)?.classList.remove("activeradio");
    if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"]:checked`).checked = false;
  }
  if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shoulder Type?]"]:checked`) || document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shoulder Type?]"].activeradio`)){
    document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shoulder Type?]"]:checked`)?.classList.remove("activeradio");
    document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shoulder Type?]"].activeradio`)?.classList.remove("activeradio");
    if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shoulder Type?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shoulder Type?]"]:checked`).checked = false;
  }
  if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"]:checked`) || document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"].activeradio`)){
    document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"]:checked`)?.classList.remove("activeradio");
    document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"].activeradio`)?.classList.remove("activeradio");
    if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"]:checked`).checked = false;
  }  
  if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"]:checked`) || document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"].activeradio`)){
    document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"]:checked`)?.classList.remove("activeradio");
    document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"].activeradio`)?.classList.remove("activeradio");
    if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"]:checked`).checked = false;
  }
  if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Silhouette?]"]:checked`) || document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Silhouette?]"].activeradio`)){
    document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Silhouette?]"]:checked`)?.classList.remove("activeradio");
    document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Silhouette?]"].activeradio`)?.classList.remove("activeradio");
    if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Silhouette?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Silhouette?]"]:checked`).checked = false;
  }
  questionsCounter();
}

function setProfileQuestions(bodyShape,hipClass,height){
  console.log("setProfileQuestions>>>>>>>>>",bodyShape,hipClass,height);
  // $("[data-product-fitsmart-global] .data_drawer_one").addClass("hide");
  // $("[data-product-fitsmart-global] .data_drawer_two").removeClass("hide");
  console.log("designType",designType);
  var heightTable = {152: "5'0", 155: "5'1", 157: "5'2", 160: "5'3", 163: "5'4", 165: "5'5", 168: "5'6", 170: "5'7", 173: "5'8", 175: "5'9", 178: "5'10", 180: "5'11", 183: "6'0", 185: "6'1", 188: "6'2", 191: "6'3", 193: "6'4", 196: "6'5", 198: "6'6"};
  var bodyTypeName = {'athletic':'Athletic','average':'Slight belly','healthy':'Significant Belly'};
  var hipTable = {'flat':'Flat','standard':'Standard','heavy':'Heavy'};  
  // fitsmart exists -- so show profile questions as selected
  $(".profile_bodytype").text(bodyTypeName[bodyShape]);
  $(".profile_hip").text(hipTable[hipClass]);
  $(".profile_height").text(heightTable[height]);
  if(document.querySelector(`[data-edit-profile-ele] .ProductSize__BodyType [value="${bodyShape}"]`)) document.querySelector(`[data-edit-profile-ele] .ProductSize__BodyType [value="${bodyShape}"]`).checked = true;
  document.querySelector(`[data-edit-profile-ele] .ProductSize__BodyType [value="${bodyShape}"]`)?.classList.add("activeradio");
  if(hipClass != undefined){
    if(document.querySelector(`[data-edit-profile-ele] .ProductSize__Hip [value="${hipClass}"]`)) document.querySelector(`[data-edit-profile-ele] .ProductSize__Hip [value="${hipClass}"]`).checked = true;
    document.querySelector(`[data-edit-profile-ele] .ProductSize__Hip [value="${hipClass}"]`)?.classList.add("activeradio");
  }
  if(document.querySelector(`[data-edit-profile-ele] .ProductSize__Height [value="${height}"]`)) document.querySelector(`[data-edit-profile-ele] .ProductSize__Height [value="${height}"]`).checked = true;
  document.querySelector(`[data-edit-profile-ele] .ProductSize__Height [value="${height}"]`)?.classList.add("activeradio");

  if(document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType input:checked`)) document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType input:checked`).checked = false;
  if(document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType [value="${bodyShape}"]`)){
    var e1 = new Event("click");
    var element1 = document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType [value="${bodyShape}"]`);
    element1.dispatchEvent(e1);
  }
  if(hipClass != undefined){
    if(document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip input:checked`)) document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip input:checked`).checked = false;
    if(document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip [value="${hipClass}"]`)){
      console.log("element2 HIP");
      var e2 = new Event("click");
      var element2 = document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip [value="${hipClass}"]`);
      element2.dispatchEvent(e2);
    }
  }
  if(document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height input:checked`)) document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height input:checked`).checked = false;
  if(document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height [value="${height}"]`)){
    console.log("element3 HEIGHT");
    var e3 = new Event("click");
    var element3 = document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height [value="${height}"]`);
    element3.dispatchEvent(e3);
  }

  if(document.body.classList.contains("product-quickview")){
    document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType [value="${bodyShape}"]`)?.classList.remove("activeradio");
    if(hipClass != undefined){
      document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip [value="${hipClass}"]`)?.classList.remove("activeradio");
    }
    document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height [value="${height}"]`)?.classList.remove("activeradio");
  }
  
  setTimeout(() => {
    // if(!document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType [value="${bodyShape}"].activeradio`) && document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType [value="${bodyShape}"]`)){
    //   document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType [value="${bodyShape}"]`).checked = true;
    //   document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType [value="${bodyShape}"]`).click();
    // }
    // if(hipClass != undefined){
    //   if(!document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip [value="${hipClass}"].activeradio`) && document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip [value="${hipClass}"]`)){
    //     document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip [value="${hipClass}"]`).checked = true;
    //     document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip [value="${hipClass}"]`).click();
    //   }
    // }
    // if(!document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height [value="${height}"].activeradio`) && document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height [value="${height}"]`)){
    //   document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height [value="${height}"]`).checked = true;
    //   document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height [value="${height}"]`).click();
    // }
    if(!document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType [value="${bodyShape}"]:checked`) && document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType [value="${bodyShape}"]`)){
      document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType .activeradio`)?.classList.remove("activeradio");
      document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType [value="${bodyShape}"]`).checked = true;
      document.querySelector(`[data-fitsmart-questions-main] .ProductSize__BodyType [value="${bodyShape}"]`).click();
    }
    if(hipClass != undefined){
      if(!document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip [value="${hipClass}"]:checked`) && document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip [value="${hipClass}"]`)){
        document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip .activeradio`)?.classList.remove("activeradio");
        document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip [value="${hipClass}"]`).checked = true;
        document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Hip [value="${hipClass}"]`).click();
      }
    }
    if(!document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height [value="${height}"]:checked`) && document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height [value="${height}"]`)){
      document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height .activeradio`)?.classList.remove("activeradio");
      document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height [value="${height}"]`).checked = true;
      document.querySelector(`[data-fitsmart-questions-main] .ProductSize__Height [value="${height}"]`).click();
    }
    $(".size-pop-profile").removeClass("hide");
    $(".Im-New-Filter .ProductSize__BodyType").hide();
    if(hipClass != undefined){
      $(".Im-New-Filter .ProductSize__Hip").hide();
    }
    $(".Im-New-Filter .ProductSize__Height").hide();
    questionsCounter();
  },1500);
  // preffred fit size guide popup logic
  $(`.product-fitsmart-sizechart-item.fit-guide .ProductSize__ChartTable:not(.jackets) table`).addClass("hide");
  $(`.product-fitsmart-sizechart-item.fit-guide .ProductSize__ChartTable:not(.jackets) .${bodyShape}`).removeClass("hide");
}

function setUpdatedSizeDateAndTime(profileData){
  console.log("setUpdatedSizeDateAndTime>>>>>>>",profileData);
  console.log("designType",designType);
  var recommendedSize;
  var updateOn = profileData.updatedOn;
  var updateBy = profileData.updatedBy;
  let unix_timestamp = updateOn
  var date = new Date(unix_timestamp * 1000);
  var monthName = date.toLocaleString("default", { month: "long" });
  var day = date.getUTCDate();
  var month = date.getUTCMonth() + 1;
  var year = date.getUTCFullYear();
  if(day < 10){
    day = '0'+day;
  }
  if(month < 10){
    month = '0'+month;
  }
  var exFormate1;
  if(day == 01){
    exFormate1 = 'st ';
  }else if(day == 02){
    exFormate1 = 'nd ';
  }else if(day == 03){
    exFormate1 = 'rd ';
  }else{
    exFormate1 = 'th ';
  }
  var formattedLongtime = day + exFormate1 + monthName +" "+ year;
  console.log('pdata',profileData);
  // if (profileData.designType == designType) {
    setTimeout(function(){
      console.log("formattedLongtime_2",formattedLongtime);
      $('.timeAndStore').html(updateBy + '<br> Updated Your size on '+formattedLongtime);
      $('.pro-updated-size-details').removeClass("hide");
      $('[data-pro-updated-size-by]').html(updateBy);
      $('[data-pro-updated-size-date]').html(formattedLongtime);
    },500);
  // }
}

function manageLocalFitsmart(){
  console.log("manageLocalFitsmart>>>>>>>>");
  var sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
  var JeansSize = {28: '28', 29: '29', 30: '30', 31: '31', 32: '32', 33: '33', 34: '34', 35: '35', 36: '36', 37: '37', 38: '38', 39: '39', 40: '40', 41: '41', 42: '42'};
  var heightTable = {152: "5'0", 155: "5'1", 157: "5'2", 160: "5'3", 163: "5'4", 165: "5'5", 168: "5'6", 170: "5'7", 173: "5'8", 175: "5'9", 178: "5'10", 180: "5'11", 183: "6'0", 185: "6'1", 188: "6'2", 191: "6'3", 193: "6'4", 196: "6'5", 198: "6'6"};
  var bodyTypeName = {'athletic':'Athletic','average':'Slight belly','healthy':'Significant Belly'};
  var hipClass = {'flat':'Flat','standard':'Standard','heavy':'Heavy'};  
  thefitsmartObject = localStorage.getItem("fitsmartobjNew");
  console.log('thefitsmartObject=',thefitsmartObject);
  if(thefitsmartObject){
    var fitsmartObjMain = JSON.parse(thefitsmartObject);
    var fitsmartObj = jQuery.grep(fitsmartObjMain, function(n,i){
      return (n.designType != 'READY_TO_WEAR' && n.fitSmartType != "STANDARD" && n.category != "bsc");
    });
    console.log("fitsmartObj",fitsmartObj);
    if(fitsmartObj.length){
      // fitsmart exists -- so show profile questions as selected
      setProfileQuestions(fitsmartObj[0]['_Body Type?'],fitsmartObj[0]['_Hip?'],fitsmartObj[0]['_Height?']);      
      var cateFitsmartObj = jQuery.grep(fitsmartObj, function(n,i){
        return (n.category == pdpType_low);
      });
      console.log("cateFitsmartObj",cateFitsmartObj);
      // if(cateFitsmartObj.length > 0 && cateFitsmartObj[0].designType == designType){
      if(cateFitsmartObj.length > 0){
        if(cateFitsmartObj[0].fitSmartType == "CUSTOM"){
          // $("data-pro-saved-sizing") data-pro-need-more-range
          $("[data-pro-need-more-range]").addClass("hide");
          $("[data-pro-saved-sizing]").removeClass("hide");
          $("[data-pro-standard-size-main]").addClass("hide");
          $("[data-product-fitsmart-global] .data_drawer_one").addClass("hide");
          $("[data-product-fitsmart-global] .data_drawer_two").removeClass("hide");
          if(cateFitsmartObj[0].category == 'shirt'){
            $(".profile_size").text(sizeTable[cateFitsmartObj[0]['_Shirt Size?']]);
            $(".profile_st").text(cateFitsmartObj[0]['_Shoulder Type?']);
            $(".profile_fit").text(cateFitsmartObj[0]['_Preferred Fit?']);
          }else{
            // category != shirt
            $(".profile_size_semi").text(cateFitsmartObj[0]['_Size?']);
            if(cateFitsmartObj[0]['_Silhouette?'] != undefined){
              $(".profile_sil_semi").text(cateFitsmartObj[0]['_Silhouette?']);
            }
            if(cateFitsmartObj[0]['_Preferred Fit?'] != 'NA' && cateFitsmartObj[0]['_Preferred Fit?'] != undefined){
              $(".profile_sil_semi").text(cateFitsmartObj[0]['_Preferred Fit?']);
            }            
          }
          if(cateFitsmartObj[0]['_Shirt Size?'] != undefined && cateFitsmartObj[0]['_Shirt Size?'] != "NA"){
            document.querySelector(`[data-edit-size-ele] .ProductSize__ShirtSize [value="${cateFitsmartObj[0]['_Shirt Size?']}"]`).checked = true;
            document.querySelector(`[data-edit-size-ele] .ProductSize__ShirtSize [value="${cateFitsmartObj[0]['_Shirt Size?']}"]`).classList.add("activeradio");
          }
          if(cateFitsmartObj[0]['_Shoulder Type?'] != undefined && cateFitsmartObj[0]['_Shoulder Type?'] != "NA"){
            document.querySelector(`[data-edit-size-ele] .ProductSize__ShoulderType [value="${cateFitsmartObj[0]['_Shoulder Type?']}"]`).checked = true;
            document.querySelector(`[data-edit-size-ele] .ProductSize__ShoulderType [value="${cateFitsmartObj[0]['_Shoulder Type?']}"]`).classList.add("activeradio");
          }
          if(cateFitsmartObj[0]['_Preferred Fit?'] != undefined && cateFitsmartObj[0]['_Preferred Fit?'] != "NA"){
            document.querySelector(`[data-edit-size-ele] .ProductSize__PreferredFit [value="${cateFitsmartObj[0]['_Preferred Fit?']}"]`).checked = true;
            document.querySelector(`[data-edit-size-ele] .ProductSize__PreferredFit [value="${cateFitsmartObj[0]['_Preferred Fit?']}"]`).classList.add("activeradio");
          }
          if(cateFitsmartObj[0]['_Size?'] != undefined && cateFitsmartObj[0]['_Size?'] != "NA"){
            document.querySelector(`[data-edit-size-ele] .ProductSize__ShirtSize [value="${cateFitsmartObj[0]['_Size?']}"]`).checked = true;
            document.querySelector(`[data-edit-size-ele] .ProductSize__ShirtSize [value="${cateFitsmartObj[0]['_Size?']}"]`).classList.add("activeradio");
            // if(document.querySelector(`.ProductForm__Variants .SizeSwatchList li [type="radio"][value="${cateFitsmartObj[0]['_Size?']}"]`)) document.querySelector(`.ProductForm__Variants .SizeSwatchList li [type="radio"][value="${cateFitsmartObj[0]['_Size?']}"]`).click();
            if(document.body.classList.contains("template-product") && document.body.getAttribute("data-template-type") != "template-suit-product"){
              if(document.querySelector(`.ProductForm__Variants .SizeSwatchList li [type="radio"][value="${cateFitsmartObj[0]['_Size?']}"]`)) document.querySelector(`.ProductForm__Variants .SizeSwatchList li [type="radio"][value="${cateFitsmartObj[0]['_Size?']}"]`).click();
            }else{
              if(document.querySelector(`.ProductForm__Variants .SizeSwatchList li [type="radio"][value="${cateFitsmartObj[0]['_Size?']}"]`)) handlePDPquickView(document.querySelector(`[data-pro-standard-size-main] input[type='radio'][value="${cateFitsmartObj[0]['_Size?'].toLowerCase()}"]`).dataset.variant);
              // if(sizeSwatch) handlePDPquickView($(this).attr("data-variant"));
            }
          }
          if(cateFitsmartObj[0]['_Silhouette?'] != undefined && cateFitsmartObj[0]['_Silhouette?'] != "NA"){
            if(document.querySelector(`[data-edit-size-ele] .ProductSize__Silhouette [value="${cateFitsmartObj[0]['_Silhouette?']}"]`)) document.querySelector(`[data-edit-size-ele] .ProductSize__Silhouette [value="${cateFitsmartObj[0]['_Silhouette?']}"]`).checked = true;
            document.querySelector(`[data-edit-size-ele] .ProductSize__Silhouette [value="${cateFitsmartObj[0]['_Silhouette?']}"]`)?.classList.add("activeradio");
          }          
        }else{
          checkForStandardSizeLocal();
        }
      // if no category fitsmart found
      }else{
        $("[data-pro-need-more-range]").removeClass("hide");
        $("[data-pro-saved-sizing]").addClass("hide");
        $("[data-pro-standard-size-main]").removeClass("hide");
        console.log("2296");
        resetFitsmartQuestions(true); // haveProfileData = true;
        checkForStandardSizeLocal();
        checkForRTWLocal();
      }
    }else{
      // check for STANDARD type
      console.log("check for STANDARD size 2303");
      resetFitsmartQuestions();
      checkForStandardSizeLocal();
      checkForRTWLocal();
    }
  }else{ // no thefitsmartObject
    console.log("2309");
    $("[data-pro-need-more-range]").removeClass("hide");
    $("[data-pro-standard-size-main]").removeClass("hide");
    resetFitsmartQuestions();
    questionsCounter();
  }
}
// END -- manageLocalFitsmart


function manageFitsmartLoginView(){
  console.log("manageFitsmartLoginView>>>>>>>>");
  // setProductAttributes(document.querySelector("[data-product-fitsmart-attributes-ele].active"));
  var fitsmartProfileAPI_obj = localStorage.getItem("getprofile");
  fitsmartProfileAPI_obj = JSON.parse(fitsmartProfileAPI_obj);
  console.log('fitsmartProfileAPI_obj',fitsmartProfileAPI_obj);
  var sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
  var JeansSize = {28: '28', 29: '29', 30: '30', 31: '31', 32: '32', 33: '33', 34: '34', 35: '35', 36: '36', 37: '37', 38: '38', 39: '39', 40: '40', 41: '41', 42: '42'};
  var heightTable = {152: "5'0", 155: "5'1", 157: "5'2", 160: "5'3", 163: "5'4", 165: "5'5", 168: "5'6", 170: "5'7", 173: "5'8", 175: "5'9", 178: "5'10", 180: "5'11", 183: "6'0", 185: "6'1", 188: "6'2", 191: "6'3", 193: "6'4", 196: "6'5", 198: "6'6"};
  var bodyTypeName = {'athletic':'Athletic','average':'Slight belly','healthy':'Significant Belly'};
  var hipClass = {'flat':'Flat','standard':'Standard','heavy':'Heavy'};  
  if(fitsmartProfileAPI_obj){
    fitsmartProfile = fitsmartProfileAPI_obj.fitProfiles;
    var fitsmartObj = jQuery.grep(fitsmartProfile, function(n,i){
      return (n.designType != 'READY_TO_WEAR' && n.type != "STANDARD" && n.fitProfileId != null);
    });
    console.log("fitsmartObj",fitsmartObj);
    if(fitsmartObj.length){
      var profileFitsmart = fitsmartProfileAPI_obj.profileFitsmart;
      setProfileQuestions(profileFitsmart.bodyShape,profileFitsmart.hipClass,profileFitsmart.height);
      if(pdpType_low == 'jackets' || pdpType_low == 'suit blazer' || pdpType_low == 'long jackets' || pdpType_low == 'shirt' || pdpType_low == 'bundi'){
        var cateFitsmartObj = jQuery.grep(fitsmartObj, function(n,i){
          return (n.categoryName == pdpType_low && n.designType == designType);
        });
      }else{
        // const compareDesignType = designType === "SEMI_STITCHED" ? "CUSTOM_DESIGN" : designType;
            
        // var cateFitsmartObj = jQuery.grep(fitsmartObj, function(n,i){
        //   // return (n.categoryName == pdpType_low && n.designType == designType && n.fitProfileId != null);
        //   return (n.categoryName == pdpType_low && n.designType === compareDesignType && n.fitProfileId != null);
        // });
        var cateFitsmartObj = jQuery.grep(fitsmartObj, function(n) {
          const designMatch = n.designType === designType || (designType === "SEMI_STITCHED" && n.designType === "CUSTOM_DESIGN");

          return ( n.categoryName === pdpType_low && designMatch && n.fitProfileId != null);
        });
      }
      console.log("cateFitsmartObj",cateFitsmartObj);
      if(cateFitsmartObj.length > 0){
        if(cateFitsmartObj[0].type == "CUSTOM"){
          // $("data-pro-saved-sizing") data-pro-need-more-range
          $("[data-pro-need-more-range]").addClass("hide");
          $("[data-pro-saved-sizing]").removeClass("hide");
          $("[data-pro-standard-size-main]").addClass("hide");
          $("[data-product-fitsmart-global] .data_drawer_one").addClass("hide");
          $("[data-product-fitsmart-global] .data_drawer_two").removeClass("hide");
          if(cateFitsmartObj[0].categoryName == 'shirt'){
            $(".profile_size").text(sizeTable[cateFitsmartObj[0].fitsmart.stdSize.value]);
            $(".profile_st").text(cateFitsmartObj[0].fitsmart.shoulderType.value);
            $(".profile_fit").text(cateFitsmartObj[0].fitsmart.fit.value);
          }else{
            // category != shirt
            $(".profile_size_semi").text(cateFitsmartObj[0].fitsmart.stdSize.value);
            if(cateFitsmartObj[0].fitsmart.silhouette != undefined){
              $(".profile_sil_semi").text(cateFitsmartObj[0].fitsmart.silhouette.value);
            }
            if(cateFitsmartObj[0]['_Preferred Fit?'] != 'NA' && cateFitsmartObj[0].fitsmart.fit != undefined){
              $(".profile_sil_semi").text(cateFitsmartObj[0].fitsmart.fit.value);
            }
          }
          if(cateFitsmartObj[0].fitsmart.stdSize != undefined){
            let stdVal = cateFitsmartObj[0].fitsmart.stdSize.value;
            if(cateFitsmartObj[0].category == "RELAXED_TSHIRTS" || cateFitsmartObj[0].category == "TShirts" || cateFitsmartObj[0].category == "OVERSIZED_TSHIRTS" || cateFitsmartObj[0].category == "LONG_SLEEVE_POLO_TSHIRTS"){
              stdVal = cateFitsmartObj[0].fitsmart.stdSize.value.toUpperCase();
            }
            document.querySelector(`[data-edit-size-ele] .ProductSize__ShirtSize [value="${stdVal}"]`).checked = true;
            document.querySelector(`[data-edit-size-ele] .ProductSize__ShirtSize [value="${stdVal}"]`).classList.add("activeradio");
            if(document.querySelector(`.ProductForm__Variants .SizeSwatchList li [type="radio"][value="${stdVal}"]`)) document.querySelector(`.ProductForm__Variants .SizeSwatchList li [type="radio"][value="${stdVal}"]`).click();

            if(document.body.classList.contains("template-product") && document.body.getAttribute("data-template-type") != "template-suit-product"){
              if(document.querySelector(`.ProductForm__Variants .SizeSwatchList li [type="radio"][value="${stdVal}"]`)) document.querySelector(`.ProductForm__Variants .SizeSwatchList li [type="radio"][value="${stdVal}"]`).click();
            }else{
              if(document.querySelector(`.ProductForm__Variants .SizeSwatchList li [type="radio"][value="${stdVal}"]`)) handlePDPquickView(document.querySelector(`.ProductForm__Variants .SizeSwatchList li [type="radio"][value="${stdVal}"]`).dataset.variant);
              // if(sizeSwatch) handlePDPquickView($(this).attr("data-variant"));
            }
            
          }
          if(cateFitsmartObj[0].fitsmart.shoulderType != undefined){
            document.querySelector(`[data-edit-size-ele] .ProductSize__ShoulderType [value="${cateFitsmartObj[0].fitsmart.shoulderType.value}"]`).checked = true;
            document.querySelector(`[data-edit-size-ele] .ProductSize__ShoulderType [value="${cateFitsmartObj[0].fitsmart.shoulderType.value}"]`).classList.add("activeradio");
          }
          if (cateFitsmartObj[0].category != "LONG_JACKETS") {
            if(cateFitsmartObj[0].fitsmart.fit != undefined){
              document.querySelector(`[data-edit-size-ele] .ProductSize__PreferredFit [value="${cateFitsmartObj[0].fitsmart.fit.value}"]`).checked = true;
              document.querySelector(`[data-edit-size-ele] .ProductSize__PreferredFit [value="${cateFitsmartObj[0].fitsmart.fit.value}"]`).classList.add("activeradio");
            }
          }
          // if(cateFitsmartObj[0]['_Size?'] != undefined){
          //   document.querySelector(`[data-edit-size-ele] .ProductSize__ShirtSize [value="${fitsmartObj[0]['_Size?']}"]`).checked = true;
          //   document.querySelector(`[data-edit-size-ele] .ProductSize__ShirtSize [value="${fitsmartObj[0]['_Size?']}"]`).classList.add("activeradio");
          // }
          if(cateFitsmartObj[0].fitsmart.silhouette != undefined){
            if (document.querySelector(`[data-edit-size-ele] .ProductSize__Silhouette`)) {
              document.querySelector(`[data-edit-size-ele] .ProductSize__Silhouette [value="${cateFitsmartObj[0].fitsmart.silhouette.value}"]`).checked = true;
              document.querySelector(`[data-edit-size-ele] .ProductSize__Silhouette [value="${cateFitsmartObj[0].fitsmart.silhouette.value}"]`).classList.add("activeradio");
            }
          }
          setUpdatedSizeDateAndTime(cateFitsmartObj[0]);
        }else{
          // type == STANDARD
          checkForStandardSizeLoginView();
          checkForRTWLoginView();
        }
      // if no category fitsmart found
      }else{
        $("[data-pro-need-more-range]").removeClass("hide");
        $("[data-pro-saved-sizing]").addClass("hide");
        $("[data-pro-standard-size-main]").removeClass("hide");
        var profileFitsmart = fitsmartProfileAPI_obj.profileFitsmart;
        console.log("2420");
        
        resetFitsmartQuestions(true); // haveProfileData = true;
        checkForStandardSizeLoginView();
        checkForRTWLoginView();
      }
    }else{
      // check for STANDARD type
      console.log("check for STANDARD size 2428");
      resetFitsmartQuestions();
      checkForStandardSizeLoginView();
    }
  }else{ // no thefitsmartObject
    console.log("2433");
    
    $("[data-pro-need-more-range]").removeClass("hide");
    $("[data-pro-standard-size-main]").removeClass("hide");
    resetFitsmartQuestions();
    questionsCounter();
  }
  
}
// END -- manageFitsmartLoginView

function manageStandardSize(){
  console.log("manageStandardSize>>>>>>>>");
  if(!document.querySelector('[data-pro-standard-size-main] input:checked[name="properties[_Standard Size?]"]') && document.querySelector('[data-pro-saved-sizing].hide') && !document.body.classList.contains("temp_webview")){
    $(".pro-select-standard-size-toast-msg").removeClass("hide");
    if(document.body.clientWidth <= 767){
      setTimeout(() => {
        $(".pro-select-standard-size-toast-msg").addClass("hide");
      },2000);
    }
    return false;
  }
  console.log("A2C clicked");
  if(document.querySelector('[data-pro-standard-size-main] input:checked[name="properties[_Standard Size?]"]')){
    if(document.body.classList.contains("notlogged")){
      var subSize = document.querySelector('[data-pro-standard-size-main] input:checked[name="properties[_Standard Size?]"]') ? document.querySelector('[data-pro-standard-size-main] input:checked[name="properties[_Standard Size?]"]').value : null;
      console.log(subSize ,"subSize");
      console.log(pdpType_low,"pdpType_low");
      if(pdpType_low == "relaxed t-shirts" || pdpType_low == "t-shirts" || pdpType_low == "oversized t-shirts" || pdpType_low == "long sleeve polo t-shirts"){
        subSize = subSize.toUpperCase();
      }
      let fitSmartType = "STANDARD";
      setLocalStoreData("","","",subSize,"","",subSize,"",pdpType_low,designType,fitSmartType);
      console.log(setLocalStoreData,"setLocalStoreData");    
      if(subSize != 'undefined'){
        if(pdpType_low == 'shirt'){
          let sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
          subSize = sizeTable[subSize];
        }
        console.log("2460");
        $('[data-standard-rec-size]').html(`${subSize}`).parents(".standard-rec-size-content").removeClass("hide");
      }
    }else{
      // logged in
      // let sizeTable = {'36':'xs','38':'s','40':'m','42':'l','44':'xl','46':'xxl','48':'xxxl','50':'4xl','52':'5xl','54':'6xl','56':'7xl'};
      let sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
      var standardSize = recStandardSize = document.querySelector('[data-pro-standard-size-main] input:checked[name="properties[_Standard Size?]"]').value || null;
      console.log("standardSize",standardSize);
      if(standardSize != null){
        if(pdpType_low == 'shirt'){
          recStandardSize = sizeTable[standardSize];
        }
        let pdpCat = getCreateMeasurementCategory(pdpType_low);
        if(pdpType_low == 'stretch denim' || pdpType_low == 'mid rise stretch jeans' || pdpType_low == 'relaxed t-shirts' || pdpType_low == 'oversized t-shirts' || pdpType_low == 'long sleeve polo t-shirts' || pdpType_low == 'rigid denim' || pdpType_low == 'casual chinos' || pdpType_low == 'pleated chinos' || pdpType_low == 'lounge pants' || pdpType_low == 'mid rise lounge pants' || pdpType_low == 'relaxed linen pants' || pdpType_low == 'fatigue pants' || pdpType_low == 'wide leg pants'){
           designType = 'HEMMING';
        }   

        if (pdpType_low == "Chinos" && designType == "HEMMING") {
          designType = 'HEMMING';
        } else if (pdpType_low == "Chinos" && designType == "SEMI_STITCHED") {
          designType = 'SEMI_STITCHED';
        }
        console.log("designType",designType,'Chinos ss',pdpCat);
           
        if (pdpCat == "Long Jackets") {
          pdpCat = "LONG_JACKETS";
        }
        var bscArr = [];
        var bscData = {
          "gender": "Male",
          "category": pdpCat,
          "fit": "NA",
          "brand": "BOM",
          "designType": designType,
          "type":"STANDARD",
          "fitSmart": {
          "stdSize": standardSize
          }
        }
        if(pdpCat == 'NEAPOLITAN_DRESS_PANTS' || pdpCat == 'SMARTPANTS' || pdpCat == 'LINEN_PANTS' || pdpCat == 'TShirts'){
          delete bscData.designType;
        }
        if(pdpType_low == 'dress pants' && designType == "HEMMING"){
          bscData["silhouette"] = "NA";
        } else if (pdpType_low == 'dress pants' && designType == "SEMI_STITCHED") {
          bscData["silhouette"] = "Straight";
        }
        bscArr.push(bscData);      
        setTimeout(() => {
          console.log("A2C with standard size createMeasurement");
          if(createMeasurementCOUNTER == 0){
            createMeasurement1(bscArr);
            createMeasurementCOUNTER = 1;
          }
        }, 500);
        if(recStandardSize != 'undefined'){
          console.log("2507");
          $('[data-standard-rec-size]').html(`${recStandardSize}`).parents(".standard-rec-size-content").removeClass("hide");
        }
      }
    }
  }
}
// END -- manageStandardSize

function manageProductFitsmart(){
  console.log("manageProductFitsmart>>>>>>>>>");
  if(document.body.classList.contains("notlogged")){
     manageLocalFitsmart();
  }else{
    // if(designType != "READY_TO_WEAR"){
      getCustomerProfileAPIData(fitsmartCustomerId);
    // }
  }
}

function manageProductFitsmartModule(templateType = 'template-bsc',pdpType_low,designType = 'CUSTOM_DESIGN'){
  console.log("manageProductFitsmartModule>>>>>>>>.");
  manageProductFitsmart();
}
// if(!document.body.classList.contains("temp_picarioview") && !document.body.classList.contains("temp_semi-customise-v21") && !document.body.classList.contains("temp_guest") && !document.body.classList.contains("template-login") && !document.body.classList.contains("template-collection") && !document.body.classList.contains("template-page") && !document.body.classList.contains("template-order")){
if(document.body.classList.contains("template-product") && !document.body.classList.contains("temp_picarioview")){
  manageProductFitsmartModule('',pdpType_low,designType);
}

// data-pro-fitsmart-guide -- GUIDE btn click event
$(document).on("click","[data-pro-fitsmart-guide]",function(e){
  e.preventDefault();
  if($(this).attr("data-id") == "product-fit-guide" && !document.body.classList.contains("fitsmart-edit")){
    var allowToReturn = false;
    if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"]`) && (!document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Body Type?]"]:checked`) || !document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"]:checked`))){
      allowToReturn = true;
    }else if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"]`) && (!document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Body Type?]"]:checked`) || !document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"]:checked`))){
      allowToReturn = true;
    }
    console.log("allowToReturn",allowToReturn);
    if(allowToReturn){
      document.querySelector('[data-fit-toast-msg]').classList.add("show-msg");
      setTimeout(() => {
        document.querySelector('[data-fit-toast-msg]').classList.remove("show-msg");
      },2000);
      return false;
    }
  }
  console.log("guide btn clicked",this,this.dataset.id);
  $(`.product-fitsmart-sizechart-item`).removeClass("active");
  console.log("ele",document.querySelector(`#${this.dataset.id}`));
  document.querySelector(`#${this.dataset.id}`)?.classList.add("active");
  if($(this).attr("data-id") == "product-standard-size-guide" || $(this).attr("data-id") == "product-rtw-size-guide"){
    document.body.classList.add("fitsmart-popup");
  }
  document.body.classList.add("fitsmart-sizechart");
  // if(this.dataset.id == "product-fit-guide"){
  // }
  initFitsmartSliders();
});
// product-fitsmart-sizechart-close -- GUIDE CLOSE btn click event
$(document).on("click","[data-product-fitsmart-sizechart-close], body.fitsmart-sizechart .product-fitsmart-overlay",function(e){
  console.log("product-fitsmart-sizechart-close btn clicked");
  e.preventDefault();
  if(document.querySelector(".product-fitsmart-sizechart-item.standard-size-guide.active") || document.querySelector(".product-fitsmart-sizechart-item.rtw-size-guide.active")){
    document.body.classList.remove("fitsmart-popup");
  }
  document.body.classList.remove("fitsmart-sizechart");
});

// data-pro-sizechart-tab-btn -- Fit Guide && Measuring Tips CLICK event
$(document).on("click","[data-pro-sizechart-tab-btn]",function(e){
  e.preventDefault();
  console.log("data-pro-sizechart-tab-btn clicked",$(this).attr("data-class"));
  $(this).addClass("active").siblings().removeClass("active");
  $(`.product-fitsmart-sizechart-item.active .product-sizechart-tab.${$(this).attr("data-class")}`).addClass("active").siblings().removeClass("active");
  initFitsmartSliders();
});

// data-pro-measuring-tips-btn -- Measuring Tips btns CLICK event
$(document).on("click","[data-pro-measuring-tips-btn]",function(e){
  e.preventDefault();
  console.log("data-pro-measuring-tips-btn clicked");
  $(this).addClass("active").siblings().removeClass("active");
  $(`.product-fitsmart-sizechart-item.active .pro-measuring-tips-tab.${$(this).attr("data-class")}`).addClass("active").siblings().removeClass("active");
});

// sizechart table links click event
$(document).on("click",".pro-sizechart-table-main .measure_data",function(e){
  e.preventDefault();
  console.log("measure_data clicked");
  let dataVal = $(this).attr("data-measure");
  $(`.product-fitsmart-sizechart-item.active [data-class="tab-measuring-tips"]`).addClass("active").siblings().removeClass("active");
  $(`.product-fitsmart-sizechart-item.active .product-sizechart-tab.tab-measuring-tips`).addClass("active").siblings().removeClass("active");
  $(`.product-fitsmart-sizechart-item.active [data-class="${dataVal}"]`).addClass("active").siblings().removeClass("active");
  initFitsmartSliders();
});

var flktyFIT;
function initFitsmartSliders(){
  console.log("initFitsmartSliders>>>>>>");
  if($('.pro-measuring-tips-tabs.with-slider').hasClass('flickity-enabled')){
    $('.pro-measuring-tips-tabs.with-slider').flickity('destroy');
  }
  var flktyMT = $('.pro-measuring-tips-tabs.with-slider:not(.flickity-enabled)').flickity({
    wrapAround: false,
    pageDots: false,
    draggable: '>1',
    contain: true,
    cellAlign: "left",
    prevNextButtons: true
  });

  if($('.preferredfit-item-list').hasClass('flickity-enabled')){
    $('.preferredfit-item-list').flickity('destroy');
  }
  flktyFIT = $('.preferredfit-item-list:not(.flickity-enabled)').flickity({
    wrapAround: false,
    pageDots: false,
    draggable: '>1',
    contain: true,
    cellAlign: "left",
    prevNextButtons: true
  });
  var bType = $('.ProductSize__Elements.ProductSize__BodyType [name="properties[_Body Type?]"]:checked').val();
  var selSize = $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"]:checked').val();

  // pdpType_low
  var superSlimHTML = $(`<div class="product-sizechart-item product-sizechart-item-superslim">
    <div class="product-sizechart-item-image"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/super-slim.svg" alt="Super Slim" loading="lazy"/></div>
    <div class="product-sizechart-item-info"><h3 class="Heading">Super Slim</h3><p>Very fitted along the waist and biceps to give you a body hugging fit.</p></div>
  </div>`);
  if(bType == 'healthy'){
    if(selSize == 'xxxl' || selSize == 'xxl' || selSize == '4xl' || selSize == '5xl' || selSize == '6xl' || selSize == '7xl'){
      if(flktyFIT) flktyFIT.flickity( 'remove', document.querySelector('.product-sizechart-item-superslim'));
    }else{
      if(pdpType_low == "shirt" && $(".product-sizechart-item-superslim").length == 0){
        flktyFIT.flickity( 'insert', superSlimHTML, 0);
        flktyFIT.flickity( 'selectCell', 0);
      }
    }
  }else if(bType == 'average'){
    if(selSize == 'xxxl' || selSize == 'xxl' || selSize == '4xl' || selSize == '5xl' || selSize == '6xl' || selSize == '7xl'){
      if(flktyFIT) flktyFIT.flickity( 'remove', document.querySelector('.product-sizechart-item-superslim'));
    }else{
      if(pdpType_low == "shirt" && $(".product-sizechart-item-superslim").length == 0){
        flktyFIT.flickity( 'insert', superSlimHTML, 0);
        flktyFIT.flickity( 'selectCell', 0);
      }
    }
  }else{
    if(pdpType_low == "shirt" && $(".product-sizechart-item-superslim").length == 0){
      flktyFIT.flickity( 'insert', superSlimHTML, 0);
      flktyFIT.flickity( 'selectCell', 0);
    }
  }
}

/*
=================================================
CUSTOMISE View ======> START
=================================================
*/
// $('[data-pro-customise-popup-close-btn]').click(function(e){
$(document).on('click','[data-pro-customise-popup-close-btn]',function(e){
  e.preventDefault();
  console.log('data-pro-customise-popup-close-btn clicked');
  if(document.body.classList.contains("temp_webview")){
    if(document.body.classList.contains("temp_picarioview")){
      if(document.querySelectorAll(".common-btn-edit.added").length > 0 || location.href.includes("editCustomisations")){
        document.body.classList.add("exit-customisation-alert");
      }else{
        const closeActionParams = {
          "appmakerAction": {
          "action": "CLOSE_MODAL",
          "params": {}
          }
        }
        sendMessageToApp(closeActionParams);
      }
    }else{
      // template semi-stitched
      if(location.href.includes("editCustomisations")){
        const closeActionParams = {
          "appmakerAction": {
          "action": "CLOSE_MODAL",
          "params": {}
          }
        }
        sendMessageToApp(closeActionParams);
      }else{
        document.body.classList.add("exit-customisation-alert");
      }
    }
  }else{
    if(location.href.includes("editCustomisations")){
      location.href = '/cart';
    }else{
      // if(document.body.classList.contains("template-bsc") && !document.body.classList.contains("collection")){
      // if(document.body.classList.contains("template-bsc")){
      if(templateType == "template-bsc"){
        if(document.querySelectorAll(".common-btn-edit.added").length > 0){
          document.body.classList.add("exit-customisation-alert");
        }else{
          if(document.querySelector('.customise-box')) document.querySelector('.customise-box').classList.add('hide');
          document.body.classList.remove('picario_open');
        }
      }else{
        // template semi-stitched
        document.body.classList.add("exit-customisation-alert");
      }
    }
  }
});

// $('[data-pro-customise-alert-popup-close]').click(function(e){
$(document).on("click","[data-pro-customise-alert-popup-close]",function(e){
  e.preventDefault();
  console.log('data-pro-customise-alert-popup-close clicked');
  document.body.classList.remove("exit-customisation-alert");
});

$(document).on("click","[data-save-customisations-btn]",function(e){
  e.preventDefault();
  console.log('data-save-customisations-btn clicked');
  document.body.classList.remove("exit-customisation-alert");
  if(document.body.classList.contains("temp_webview")){
    var productFormElems = document.querySelector(".ProductForm");
    var newData = $(productFormElems).serializeArray();
    console.log('profileAPIData',profileAPIData);
    console.log("data-save-customisations-btn --> newData",newData);
    
    const addToCartParams = {"appmakerAction": {"action": "SAVE_CUSTOMISATION","params": {"closeModal":true,"data": newData , "fitsmartData" : profileAPIData }}}
    sendMessageToApp(addToCartParams);
    const closeActionParams = {
      "appmakerAction": {
        "action": "CLOSE_MODAL",
        "params": {}
      }
    }
    sendMessageToApp(closeActionParams);
  }else{
    if(document.querySelector('.customise-box')) document.querySelector('.customise-box').classList.add('hide');
    document.body.classList.remove('picario_open');
    document.body.classList.remove('open_semicustom');
  }
});

$(document).on("click","[data-discard-customisations-btn]",function(e){
  e.preventDefault();
  console.log('data-discard-customisations-btn clicked');
  document.body.classList.remove("exit-customisation-alert");
  if(document.body.classList.contains("temp_webview")){
    const closeActionParams = {
      "appmakerAction": {
        "action": "CLOSE_MODAL",
        "params": {}
      }
    }
    sendMessageToApp(closeActionParams);
  }else{
    // var url = location.href.split('?')[0];
    // console.log('url',url);
    // location.href= url;
    $("[data-save-customisations-btn]").click();
    setTimeout(() => {
      $(`[name="properties[_customized_attributes]"]`).val("");
      $(`.common-btn-edit`).removeClass("added");
    },500);
  }
});
/*
=================================================
CUSTOMISE View ======> END
=================================================
*/

/*
=================================================
PRODUCT QUICK VIEW ======> START
=================================================
*/
$(document).on("click","[data-close-product-quickview]",function(e){
  e.preventDefault();
  console.log("data-close-product-quickview clicked");
  document.body.classList.remove("product-quickview","picario_open","customizationOpen","show-rtw-details","picario_open");
  $('#main').removeClass('customiseBox--open');
  $('.customise-box').addClass('hide');
  $('.customise-popup').addClass('hide');
  $('html').removeClass('no-scroll');
  
  if(document.querySelector('[data-pro-need-more-range]')) document.querySelector('[data-pro-need-more-range]').classList.add("hide");
  if(document.querySelector('[data-pro-saved-sizing]')) document.querySelector('[data-pro-saved-sizing]').classList.add("hide");
  if(document.querySelector('[data-pro-standard-size-main]')) document.querySelector('[data-pro-standard-size-main]').classList.add("hide");
  document.querySelector('[data-product-quickview-main] .ProductForm').classList.remove("loaded");

  $("[data-product-quickview-main]").html(decodeHTML($('[data-product-quickview-pdpdata]').html()));
});
/*
=================================================
PRODUCT QUICK VIEW ======> END
=================================================
*/



function initFitsmartView(proHandle, showFullDetails = true,cateFitsmart){
  var origin = window.location.origin;
  // var mainProId = `template--18002557468835__main`; // real time generated section_id
  
  var fetchURL = `${origin}/products/${proHandle}?view=quickview`;
  fetch(fetchURL,{
  method:'GET', headers: {
  'Content-Type': 'application/json'}
  })
  .then((response) =>{
    console.log("response",response);
  return response.text();
  }).then(data =>{
    let parser = new DOMParser();
    let parsedHtml = parser.parseFromString(data, 'text/html');
    // console.log("parsedHtml",parsedHtml); // new HTML
    // console.log("parsedHtml",parsedHtml.querySelector("[data-atr]").innerHTML);
    setProductAttributes(parsedHtml.querySelector("[data-product-fitsmart-attributes-ele]"));
    // if(pdpType_low != "t-shirts"){
    if(templateType == "template-semi-stitched"){
      subAttr = parsedHtml.querySelector("[data-atr]")? JSON.parse(parsedHtml.querySelector("[data-atr]").innerHTML) : "";

      if(atr){
        if (atr.designType === "ACCESSORIES") {
          document.querySelector(".select-size-span").innerText = "Add Accessories";
        }
      }

      console.log("subAttr",subAttr);
    }else{
      atr = parsedHtml.querySelector("[data-atr]")? JSON.parse(parsedHtml.querySelector("[data-atr]").innerHTML) : "";
      console.log("atr",atr);
    }
    // }

    // if(pdpType_low != "t-shirts"){
    if(parsedHtml.querySelector("[data-product-json]")){
      // var proVariants = JSON.parse(parsedHtml.querySelector("[data-variant-json]").innerHTML);
      var proVariants = JSON.parse(parsedHtml.querySelector("[data-product-json]").innerHTML);
      var variantJson = [];
      proVariants.product.variants.forEach(variant => {
        variantJson.push({variantID:`${variant.id}`,variantTitle:variant.title,variantAvailability:variant.available});        
      });
      console.log("variantJson",variantJson);
      // return;
      if($(parsedHtml).find('[name="properties[_productJson]"]').length > 0){
        console.log("variantJson",variantJson);
        $(parsedHtml).find('[name="properties[_productJson]"]').val(JSON.stringify(variantJson));
      }
    }
    // }
    // data-product-quickview-main
    // document.querySelector('[data-product-quickview-main]').innerHTML = parsedHtml.querySelector('.Product__InfoWrapper').outerHTML;

    if(showFullDetails){
      document.querySelector(`.product-quickview-global`).classList.remove("necessary-details");
      document.querySelector('[data-product-quickview-main]').innerHTML = parsedHtml.querySelector('.main-product-section').outerHTML;
      // document.body.classList.add("product-quickview");
      setTimeout(() => {
        document.querySelector('[data-great-choice-popup-main] .modal-body').innerHTML = parsedHtml.querySelector('[data-great-choice-popup-main] .modal-body').innerHTML;
        document.querySelector('[data-product-fitsmart-global]').innerHTML = parsedHtml.querySelector('[data-product-fitsmart-global]').innerHTML;
      },500);
  
      // $(`#main .customise-box, #main .customize-shirt`).remove()
      var swiperQuickView = new Swiper("[data-product-quickview-main] .Product__Slideshow", {
        loop: true,
        pagination: {
          el: "[data-product-quickview-main] .pdp-swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      });
  
      if($(".new-color-varient .inner_metacolor .var-outer").length > 5 && document.body.clientWidth >= 1008){
        setTimeout(() => {
        // $(".new-color-varient .inner_metacolor .var-outer").length
        var flkty1 = $('.new-color-varient .inner_metacolor').flickity({
          wrapAround: false,
          pageDots: false,
          groupCells: '3',
          adaptiveHeight: false,
          // initialIndex: 0,
          contain: true,
          cellAlign: "left",
          prevNextButtons: true,
          imagesLoaded: true,
          autoPlay: false,
          draggable: '>5'
        });
        },2000);
      }
    }else{
      // necessary-details
      document.querySelector(`.product-quickview-global`).classList.add("necessary-details");
      parsedHtml.querySelector('.swiper.Product__Slideshow')?.remove();
      // if(document.querySelector('[data-pro-need-more-range]')) document.querySelector('[data-pro-need-more-range]').classList.add("hide");
      // if(parsedHtml.querySelector('[data-pro-saved-sizing]')) parsedHtml.querySelector('[data-pro-saved-sizing]').classList.add("hide");
      if(parsedHtml.querySelector('.pro-accordion-main')) parsedHtml.querySelector('.pro-accordion-main').remove();
      if(parsedHtml.querySelector('.new-color-varient')) parsedHtml.querySelector('.new-color-varient').remove();

      console.log("accProd",pdpType_low);
      
      if (pdpType_low == "TIES" || pdpType_low == "POCKET_SQUARE" || pdpType_low == "METAL_CUFFLINKS" || pdpType_low == "SILK_KNOTS" || pdpType_low == "COLLAR_PIN"){
          $(parsedHtml).find(".ProductForm__AddToCart").removeClass("btn_notclick");
          $(parsedHtml).find(".pro-wishlist-wrap").removeClass("btn_notclick");
      } else {
          $(parsedHtml).find(".ProductForm__AddToCart").addClass("btn_notclick");
          $(parsedHtml).find(".pro-wishlist-wrap").addClass("btn_notclick");
      }

      if(cateFitsmart.length > 0 && cateFitsmart[0].designType == "READY_TO_WEAR"){
        parsedHtml.querySelector('.rtw-mobile-slide [name="properties[_size]"]:checked')?.removeAttribute("checked");
      }
      $(parsedHtml).find(".product-fitsmart-sizechart-item.rtw-size-guide").addClass("active");
      $(parsedHtml).find(".product-fitsmart-sizechart-item.standard-size-guide").addClass("active");
      // replace HTML
      document.querySelector('[data-product-quickview-main]').innerHTML = parsedHtml.querySelector('.main-product-section').outerHTML;

      if(cateFitsmart.length > 0){
      if(document.body.classList.contains("logged")){
        if(cateFitsmart[0].type == "STANDARD"){
          $("[data-pro-standard-size-main], [data-pro-need-more-range], .standard-rec-size-content").removeClass("hide");
          $("[data-pro-saved-sizing]").addClass("hide");
          let sizeselect = cateFitsmart[0].fitsmart.stdSize.value;
          if(cateFitsmart[0].categoryName == 'shirt'){
            let sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
            sizeselect = sizeTable[sizeselect];
          }
          $("[data-standard-rec-size]").html(`${sizeselect}`);
          if(document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmart[0].fitsmart.stdSize.value}"]`)) document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmart[0].fitsmart.stdSize.value}"] ~ label`).classList.add("temp-activeradio");
        }else{
          console.log("CUSTOM----------->");
          $("[data-pro-standard-size-main], [data-pro-need-more-range]").addClass("hide");
          $("[data-pro-saved-sizing]").removeClass("hide");
          // setUpdatedSizeDateAndTime(cateFitsmart[0],0);
    
          var profileData = cateFitsmart[0];
          var recommendedSize;
          var updateOn = profileData.updatedOn;
          var updateBy = profileData.updatedBy;
          let unix_timestamp = updateOn
          var date = new Date(unix_timestamp * 1000);
          var monthName = date.toLocaleString("default", { month: "long" });
          var day = date.getUTCDate();
          var month = date.getUTCMonth() + 1;
          var year = date.getUTCFullYear();
          if(day < 10){
            day = '0'+day;
          }
          if(month < 10){
            month = '0'+month;
          }
          var exFormate1;
          if(day == 01){
            exFormate1 = 'st ';
          }else if(day == 02){
            exFormate1 = 'nd ';
          }else if(day == 03){
            exFormate1 = 'rd ';
          }else{
            exFormate1 = 'th ';
          }
          var formattedLongtime = day + exFormate1 + monthName +" "+ year;
          console.log('pdata',profileData);
          // setTimeout(function(){
            console.log("formattedLongtime_2",formattedLongtime);
            $('[data-product-quickview-main] .timeAndStore').html(updateBy + '<br> Updated Your size on '+formattedLongtime);
            $('[data-product-quickview-main] .pro-updated-size-details').removeClass("hide");
            $('[data-product-quickview-main] [data-pro-updated-size-by]').html(updateBy);
            $('[data-product-quickview-main] [data-pro-updated-size-date]').html(formattedLongtime);
          // },0);

          if(cateFitsmart[0].designType == "READY_TO_WEAR"){
            // $('.rtw-rec-size').html('size <span>'+ cateFitsmart[0].fitsmart.stdSize.value +'</span> Recommended');
            $('.rtw-rec-size').html('Your last Selected Size : <span>'+ cateFitsmart[0].fitsmart.stdSize.value +'</span>');
             
            $(".rtw-size-header").removeClass("hide");
            if(document.querySelector(`.rtw-mobile-slide .SizeSwatch__Radio[value="${cateFitsmart[0].fitsmart.stdSize.value}"]`)) document.querySelector(`.rtw-mobile-slide .SizeSwatch__Radio[value="${cateFitsmart[0].fitsmart.stdSize.value}"] ~ label`).classList.add("temp-activeradio");
          }
        }    
      }else{// notlogged
        // if(cateFitsmart.length > 0){
          if(cateFitsmart[0].fitSmartType == "STANDARD"){
            $("[data-product-quickview-main] [data-pro-standard-size-main], [data-product-quickview-main] [data-pro-need-more-range], [data-product-quickview-main] .standard-rec-size-content").removeClass("hide");
            $("[data-product-quickview-main] [data-pro-saved-sizing]").addClass("hide");
            let sizeselect = cateFitsmart[0].getsize;
            if(cateFitsmart[0].category == 'shirt'){
              let sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
              sizeselect = sizeTable[sizeselect];
            }
            $("[data-standard-rec-size]").html(`${sizeselect}`);
            if(document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmart[0]["getsize"]}"]`)) document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmart[0]["getsize"]}"] ~ label`).classList.add("temp-activeradio");
          }else{
            console.log("CUSTOM----------->")
            $("[data-product-quickview-main] [data-pro-standard-size-main], [data-pro-need-more-range]").addClass("hide");
            $("[data-product-quickview-main] [data-pro-saved-sizing]").removeClass("hide");

            if(cateFitsmart[0].designType == "READY_TO_WEAR"){
              // $('.rtw-rec-size').html('size <span>'+ cateFitsmart[0]["_Shirt Size?"] +'</span> Recommended');
              $('.rtw-rec-size').html('Your last Selected Size : <span>'+ cateFitsmart[0]["_Shirt Size?"] +'</span>');
              
              $(".rtw-size-header").removeClass("hide");
              if(document.querySelector(`.rtw-mobile-slide .SizeSwatch__Radio[value="${cateFitsmart[0]["_Shirt Size?"]}"]`)) document.querySelector(`.rtw-mobile-slide .SizeSwatch__Radio[value="${cateFitsmart[0]["_Shirt Size?"]}"] ~ label`).classList.add("temp-activeradio");
            }
          }
        // }else{
        //   $("[data-product-quickview-main] [data-pro-standard-size-main], [data-pro-need-more-range]").removeClass("hide");
        //   $("[data-product-quickview-main] [data-pro-saved-sizing]").addClass("hide");
        // }
      }
      }else{
        $("[data-product-quickview-main] [data-pro-standard-size-main], [data-pro-need-more-range]").removeClass("hide");
        $("[data-product-quickview-main] [data-pro-saved-sizing]").addClass("hide");
      }
      
      // document.body.classList.add("product-quickview");
      // document.querySelector('[data-product-quickview-main] .ProductForm').classList.add("loaded");
      setTimeout(() => {
        document.querySelector('[data-great-choice-popup-main] .modal-body').innerHTML = parsedHtml.querySelector('[data-great-choice-popup-main] .modal-body').innerHTML;
        document.querySelector('[data-product-fitsmart-global]').innerHTML = parsedHtml.querySelector('[data-product-fitsmart-global]').innerHTML;
      },500);
      
    }
    

    setTimeout(() => {
      if(templateType == 'template-rtw'){
        manageProductsRTW();
      }
      localStorage.needToGetCustomerProfileData = true;
      manageProductFitsmartModule(templateType,pdpType_low,designType);
      window.ajaxifiedAddToCart._initAddToCart();
      // document.body.classList.add("product-quickview");
      // $(".ProductForm__AddToCart").removeClass("btn_notclick");
      let btnInterval;
      btnInterval = setInterval(() => {
        if(document.querySelector(`[data-product-quickview-main] [name="properties[_attributes]"]`) && document.querySelector(`[data-product-quickview-main] [name="properties[_attributes]"]`).value != ""){
          console.log(document.querySelector(`[data-product-quickview-main] [name="properties[_attributes]"]`).value,"prod-sizing-here");
          
          $(".ProductForm__AddToCart").removeClass("btn_notclick");
          clearInterval(btnInterval);
        }else if(templateType == "template-rtw"){
          $(".ProductForm__AddToCart").removeClass("btn_notclick");
          clearInterval(btnInterval);
        }
      },500);
      
    },500);
    console.log("templateType",templateType);
    setTimeout(() => {
      if(templateType != "template-rtw"){
        if(document.querySelector(`[data-product-quickview-main] .temp-activeradio`)) document.querySelector(`[data-product-quickview-main] .temp-activeradio`).classList.remove("temp-activeradio");
      }
      if(templateType == "template-semi-stitched"){
        manageCustomizeSemiStitched();
      }else{
        if(templateType != "template-rtw"){
          manageCustomize();
        }
      }
      if(_swat) _swat.initializeActionButtons("body");
      $(".pro-wishlist-wrap").removeClass("btn_notclick");
    },2000);
  });
}
// end -- initFitsmartView

$(document).on("click","[data-pro-quickview-open-btn]",function(e){
  e.preventDefault();

  // get category fitsmart size type
  var cateFitsmart = getFitsmartSizeType($(this).attr("data-type"),$(this).attr("data-template"),$(this).attr("data-designtype"));
  console.log("cateFitsmart????????????",cateFitsmart);
  

  templateType = `template-${$(this).attr("data-template").toLowerCase()}`;  
  
  if ($(this).attr("data-title") != undefined) {
    document.querySelector(`[data-product-quickview-main] .title-view-main .ProductMeta__Title`).innerHTML = $(this).attr("data-title");
  }
  if ($(this).closest('.Grid__Cell').find('.ProductItem__Price').html() != undefined) {
    document.querySelector(`[data-product-quickview-main] .ProductMeta__PriceList .ProductMeta__Price`).innerHTML = $(this).closest('.Grid__Cell').find('.ProductItem__Price').html();
  }
  
  // console.log($(this).closest('.Grid__Cell').find('.grid-menbership').html(),"$(this).closest('.menbership').");
  // return;
  if ($(this).closest('.Grid__Cell').find('.grid-menbership').html() != undefined) {
    document.querySelector(`[data-product-quickview-main] .grid-menbership`).innerHTML = $(this).closest('.Grid__Cell').find('.grid-menbership').html();
  } else {
    document.querySelector(`[data-product-quickview-main] .grid-menbership`)?.classList.add("hide");
  }

  if($(this).closest('.Grid__Cell').find('.ProductItem__LabelList').length){
    document.querySelector(`[data-product-quickview-main] .ProductItem__LabelList`).innerHTML = $(this).closest('.Grid__Cell').find('.ProductItem__LabelList').html();
  }else{
    document.querySelector(`[data-product-quickview-main] .ProductItem__LabelList`)?.classList.add("hide");
  }

  // console.log("html>>>>>>>>",$(this).closest('.Grid__Cell').find('[data-standard-size-html]').html());
  // return;
  if(($(this).closest('.Grid__Cell').find('[data-standard-size-html]').html()) != undefined){
    $(".pro-standard-size-quickview").html(decodeHTML($(this).closest('.Grid__Cell').find('[data-standard-size-html]').html()));
  } 
  
  if (pdpType_low == "TIES" || pdpType_low == "POCKET_SQUARE" || pdpType_low == "METAL_CUFFLINKS" || pdpType_low == "SILK_KNOTS" || pdpType_low == "COLLAR_PIN"){
    $(".ProductForm__AddToCart").removeClass("btn_notclick");
    $(".pro-wishlist-wrap").removeClass("btn_notclick");
  } else {
    $(".ProductForm__AddToCart").addClass("btn_notclick");
    $(".pro-wishlist-wrap").addClass("btn_notclick");
  }

  let type = $(this).attr("data-type").toLowerCase();
  console.log("type",type);
  let sizechartHTML = decodeHTML($(`[data-all-cate-sizechart]`).html());
  // console.log(sizechartHTML,"sizechartHTML");
  // return;
  if(sizechartHTML != undefined){
    if($(this).attr("data-template") == "RTW"){
      sizechartHTML = decodeHTML($(`[data-all-cate-sizechart-rtw]`).html());
      let catSizechart = $(sizechartHTML).find(`#product-rtw-size-guide-${type}`).html();
      // console.log("catSizechart rtw",catSizechart);
      if(catSizechart != undefined){
        $(".product-fitsmart-sizechart-item.rtw-size-guide").addClass("active").html(catSizechart);
      }
    }else{
      let catSizechart = $(sizechartHTML).find(`#product-standard-size-guide-${type}`).html();
      // console.log("catSizechart",catSizechart);
      if(catSizechart != undefined){
        $(".product-fitsmart-sizechart-item.standard-size-guide").addClass("active").html(catSizechart);
      }
    }
  }
  

  if(cateFitsmart.length > 0){
  if(document.body.classList.contains("logged")){
    if(cateFitsmart[0].type == "STANDARD"){
      $("[data-pro-standard-size-main], [data-pro-need-more-range], .standard-rec-size-content").removeClass("hide");
      $("[data-pro-saved-sizing]").addClass("hide");
      let sizeselect = cateFitsmart[0].fitsmart.stdSize.value;
      console.log("sizeselect",sizeselect);
      if(cateFitsmart[0].categoryName == 'shirt'){
        let sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
        sizeselect = sizeTable[sizeselect];
      }
      $("[data-standard-rec-size]").html(`${sizeselect}`);
      if(document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmart[0].fitsmart.stdSize.value}"]`)) document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmart[0].fitsmart.stdSize.value}"] ~ label`).classList.add("temp-activeradio");
    }else{
      console.log("CUSTOM----------->")
      $("[data-pro-standard-size-main], [data-pro-need-more-range]").addClass("hide");
      $("[data-pro-saved-sizing]").removeClass("hide");
      // setUpdatedSizeDateAndTime(cateFitsmart[0],0);

      var profileData = cateFitsmart[0];
      var recommendedSize;
      var updateOn = profileData.updatedOn;
      var updateBy = profileData.updatedBy;
      let unix_timestamp = updateOn
      var date = new Date(unix_timestamp * 1000);
      var monthName = date.toLocaleString("default", { month: "long" });
      var day = date.getUTCDate();
      var month = date.getUTCMonth() + 1;
      var year = date.getUTCFullYear();
      if(day < 10){
        day = '0'+day;
      }
      if(month < 10){
        month = '0'+month;
      }
      var exFormate1;
      if(day == 01){
        exFormate1 = 'st ';
      }else if(day == 02){
        exFormate1 = 'nd ';
      }else if(day == 03){
        exFormate1 = 'rd ';
      }else{
        exFormate1 = 'th ';
      }
      var formattedLongtime = day + exFormate1 + monthName +" "+ year;
      console.log('pdata',profileData);
      // setTimeout(function(){
        console.log("formattedLongtime_2",formattedLongtime);
        $('.timeAndStore').html(updateBy + '<br> Updated Your size on '+formattedLongtime);
        $('.pro-updated-size-details').removeClass("hide");
        $('[data-pro-updated-size-by]').html(updateBy);
        $('[data-pro-updated-size-date]').html(formattedLongtime);
      // },0);

      if(cateFitsmart[0].designType == "READY_TO_WEAR"){
        // $('.rtw-rec-size').html('size <span>'+ cateFitsmart[0].fitsmart.stdSize.value +'</span> Recommended');
        $('.rtw-rec-size').html('Your last Selected Size : <span>'+ cateFitsmart[0].fitsmart.stdSize.value +'</span>');
        
        $(".rtw-size-header").removeClass("hide");
        if(document.querySelector(`.rtw-mobile-slide .SizeSwatch__Radio[value="${cateFitsmart[0].fitsmart.stdSize.value}"]`)) document.querySelector(`.rtw-mobile-slide .SizeSwatch__Radio[value="${cateFitsmart[0].fitsmart.stdSize.value}"] ~ label`).classList.add("temp-activeradio");
      }
      
    }
  }else{// notlogged
    // if(cateFitsmart.length > 0){
      if(cateFitsmart[0].fitSmartType == "STANDARD"){
        $("[data-pro-standard-size-main], [data-pro-need-more-range], .standard-rec-size-content").removeClass("hide");
        $("[data-pro-saved-sizing]").addClass("hide");
        let sizeselect = cateFitsmart[0].getsize;
        console.log("sizeselect",sizeselect);
        if(cateFitsmart[0].category == 'shirt'){
          let sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
          sizeselect = sizeTable[sizeselect];
        }
        console.log("sizeselect",sizeselect);
        $("[data-standard-rec-size]").html(`${sizeselect}`);
        if(document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmart[0]["getsize"]}"]`)) document.querySelector(`[data-pro-standard-size-main] input[name="properties[_Standard Size?]"][value="${cateFitsmart[0]["getsize"]}"] ~ label`).classList.add("temp-activeradio");
      }else{
        console.log("CUSTOM----------->")
        $("[data-pro-standard-size-main], [data-pro-need-more-range]").addClass("hide");
        $("[data-pro-saved-sizing]").removeClass("hide");

        if(cateFitsmart[0].designType == "READY_TO_WEAR"){
          // $('.rtw-rec-size').html('size <span>'+ cateFitsmart[0]["_Shirt Size?"] +'</span> Recommended');
          $('.rtw-rec-size').html('Your last Selected Size : <span>'+ cateFitsmart[0]["_Shirt Size?"] +'</span>');
          
          $(".rtw-size-header").removeClass("hide");
          if(document.querySelector(`.rtw-mobile-slide .SizeSwatch__Radio[value="${cateFitsmart[0]["_Shirt Size?"]}"]`)) document.querySelector(`.rtw-mobile-slide .SizeSwatch__Radio[value="${cateFitsmart[0]["_Shirt Size?"]}"] ~ label`).classList.add("temp-activeradio");
        }
      }
    // }else{
    //   $("[data-pro-standard-size-main], [data-pro-need-more-range]").removeClass("hide");
    //   $("[data-pro-saved-sizing]").addClass("hide");
    // }
  }
  }else{
    $("[data-pro-standard-size-main], [data-pro-need-more-range]").removeClass("hide");
    $("[data-pro-saved-sizing]").addClass("hide");
  }
  
  document.body.classList.add("product-quickview");
  // debugger;
  initFitsmartView($(this).attr("data-handle"),false,cateFitsmart);
});

function handlePDPquickView(variantId){
  console.log("handlePDPquickView>>>>>>>>>>>...",variantId);

  if(document.querySelector(`.ProductForm__Variants [name="id"]`)){
    document.querySelector(`.ProductForm__Variants [name="id"] [selected]`).removeAttribute("selected");
    document.querySelector(`.ProductForm__Variants [name="id"] option[value="${variantId}"]`).setAttribute("selected","selected");
    if(document.querySelector(`.ProductForm__Variants [name="id"] [selected]`).hasAttribute("disabled")){
      // Your size is out of stock
      if(document.querySelector('.ProductForm__AddToCart')){
        document.querySelector('.ProductForm__AddToCart').innerHTML = 'Your size is out of stock';
        document.querySelector('.ProductForm__AddToCart').setAttribute("disabled","disabled");
        if(document.querySelector('.korra-save-custom-size')) document.querySelector('.korra-save-custom-size').setAttribute("disabled","disabled");
      }
    }else{
      // Your size is in stock
      if(document.querySelector('.ProductForm__AddToCart')){
        document.querySelector('.ProductForm__AddToCart').innerHTML = '<span>Add to bag</span> <div class="add-cart-loader"></div>';
        document.querySelector('.ProductForm__AddToCart').removeAttribute("disabled");
        if(document.querySelector('.korra-save-custom-size')) document.querySelector('.korra-save-custom-size').removeAttribute("disabled","disabled");
      }      
    }
  }
}

function getFitsmartSizeType(type,template,designtype){
  console.log("type",type,"template",template);
  let fitsmart = [];
  type = type.toLowerCase();
  if(document.body.classList.contains("logged")){
    console.log("getFitsmartSizeType logged");
    type = getCreateMeasurementCategory(type.toLowerCase());
    console.log("type",type);
    var fitsmartProfileAPI_obj = localStorage.getItem("getprofile");
    fitsmartProfileAPI_obj = JSON.parse(fitsmartProfileAPI_obj);
    console.log('fitsmartProfileAPI_obj',fitsmartProfileAPI_obj);
    if(fitsmartProfileAPI_obj){
      fitsmartProfile = fitsmartProfileAPI_obj.fitProfiles;
      // var fitsmartObj = jQuery.grep(fitsmartProfile, function(n,i){
      //   return (n.designType != 'READY_TO_WEAR' && n.type != "STANDARD" && n.fitProfileId != null);
      // });
      var fitsmartObj = jQuery.grep(fitsmartProfile, function(n,i){
        return (n.fitProfileId != null);
      });

      if(type == "Shirts" && template == "bsc"){
        fitsmart = $.grep(fitsmartProfile, function(e){
          return e.categoryName == 'shirt' && e.designType == 'CUSTOM_DESIGN';
        });
      }else if(type == "Shirts" && template == "RTW"){
        fitsmart = $.grep(fitsmartProfile, function(e){
          return e.categoryName == 'shirt' && e.designType == 'READY_TO_WEAR';
        });
      }else if(type == "Jackets"){
        fitsmart = $.grep(fitsmartProfile, function(e){
          return e.categoryName == 'jackets' && e.designType == designtype;
        });
      }else if(type == "Suit Blazer"){
        fitsmart = $.grep(fitsmartProfile, function(e){
          return e.categoryName == 'SUIT_BLAZER' && e.designType == "SEMI_STICHED";
        });
      }else if(type == "Long Jackets"){
        fitsmart = $.grep(fitsmartProfile, function(e){
          return e.categoryName == 'LONG_JACKETS' && e.designType == "SEMI_STICHED";
        });
      }else{
        fitsmart = $.grep(fitsmartProfile, function(e){
          return e.category == type && e.fitProfileId != null;
        });
      }
      return fitsmart;
    }else{
      return fitsmart;
    }
  }else{
    fitsmartObject = localStorage.getItem("fitsmartobjNew");
    if(typeof fitsmartObject === 'undefined' || fitsmartObject === null ){
      fitsmartObject = [];
    }else{
      fitsmartObject = JSON.parse(fitsmartObject);
    }
    console.log("fitsmartObject",fitsmartObject);
    if(type == "shirt" && template == "bsc"){
      fitsmart = $.grep(fitsmartObject, function(e){
        return e.category == 'shirt' && e.designType == 'CUSTOM_DESIGN';
      });
    }else if(type == "shirt" && template == "RTW"){
      fitsmart = $.grep(fitsmartObject, function(e){
        return e.category == 'shirt' && e.designType == 'READY_TO_WEAR';
      });
    }else if(type == "jackets"){
      fitsmart = $.grep(fitsmartObject, function(e){
        return e.category == 'jackets' && e.designType == designtype;
      });
    }else if(type == "suit blazer"){
      fitsmart = $.grep(fitsmartObject, function(e){
        return e.category == 'SUIT_BLAZER' && e.designType == "SEMI_STICHED";
      });
    }else if(type == "long jackets"){
      fitsmart = $.grep(fitsmartObject, function(e){
        return e.category == 'LONG_JACKETS' && e.designType == "SEMI_STICHED";
      });
    }else{
      fitsmart = $.grep(fitsmartObject, function(e){
        return e.category == type;
      });
    }
    return fitsmart;
  }
  // return fitsmart;
}

$(document).on("click","[data-product-quickview-main] .ProductForm.rtw .ProductForm__Variants input",function(){
  console.log("RTW input clicked");
  if(document.querySelector(`[data-product-quickview-main] .ProductForm.rtw select[name="id"] option[selected]`)) document.querySelector(`[data-product-quickview-main] .ProductForm.rtw select[name="id"] option[selected]`).removeAttribute("selected");
  if(document.querySelector(`[data-product-quickview-main] .ProductForm.rtw select[name="id"] option[value="${$(this).attr("data-variant")}"]`)) document.querySelector(`[data-product-quickview-main] .ProductForm.rtw select[name="id"] option[value="${$(this).attr("data-variant")}"]`).setAttribute("selected","selected");
  if(document.querySelector(`[data-product-quickview-main] .ProductForm.rtw select[name="id"] option[value="${$(this).attr("data-variant")}"]`).hasAttribute("disabled")){
    if(document.querySelector('.ProductForm__AddToCart')){
      document.querySelector('.ProductForm__AddToCart').innerHTML = 'Your size is out of stock';
      document.querySelector('.ProductForm__AddToCart').setAttribute("disabled","disabled");
    }
  }else{
    if(document.querySelector('.ProductForm__AddToCart')){
      document.querySelector('.ProductForm__AddToCart').innerHTML = '<span>Add to bag</span> <div class="add-cart-loader"></div>';
      document.querySelector('.ProductForm__AddToCart').removeAttribute("disabled");
    }
  }
});